import React, { useEffect, useMemo, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { Modal, Button } from "react-bootstrap";
import CompletarDatosFactura from './CompletarDatosFactura';
import ModalRipsExito from '../rips/ModalRipsExito';
import { getSpaPathPrefix } from '../../../resources/Constants';
import { getEtiquetaFactura } from '../../../utils/etiquetaFactura';
import { useClientPagination } from "../reportes/useClientPagination";
import ReportPaginationFooter from "../reportes/ReportPaginationFooter";
import "./ModalExitoFacturacion.css";
import { FORMA_PAGO_OPCIONES, getFormaPagoTexto } from '../../../utils/formasPago';

/** Fecha YYYY-MM-DD en hora local (evita desfase de toISOString/UTC en Colombia). */
const ymdLocal = (d = new Date()) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const parseMontoRecibo = (raw) => {
    if (raw === '' || raw == null) return 0;
    const digits = String(raw).replace(/\D/g, '');
    if (digits === '') return 0;
    const n = parseInt(digits, 10);
    return Number.isFinite(n) ? n : 0;
};

function ListadoFacturas() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [facturas, setFacturas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [pacientes, setPacientes] = useState([]);

    const history = useHistory();
    const location = useLocation();

    /** `filtro` en query (?filtro=vencidas desde el home) para acotar vista y rangos de fecha. */
    const [filtroUrlActivo, setFiltroUrlActivo] = useState(null);

    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [busquedaDocumento, setBusquedaDocumento] = useState('');
    const [numeroFactura, setNumeroFactura] = useState('');
    const [estadoFacturaFiltro, setEstadoFacturaFiltro] = useState('');
    const [estadoDianFiltro, setEstadoDianFiltro] = useState('');
    const [tipoFacturaFiltro, setTipoFacturaFiltro] = useState('');
    const [metodoPagoFiltro, setMetodoPagoFiltro] = useState('');

    // Modal Recibo de Caja
    const [showModalRecibo, setShowModalRecibo] = useState(false);
    const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
    const [valorRecibo, setValorRecibo] = useState('');
    const [medioPago, setMedioPago] = useState('10');
    const [fechaPago, setFechaPago] = useState(ymdLocal());
    const [observacionesRecibo, setObservacionesRecibo] = useState('');

    // Modal Nota Crédito Electrónica
    const [showModalNotaCredito, setShowModalNotaCredito] = useState(false);
    const [prefijos, setPrefijos] = useState([]);
    const [prefijoSeleccionado, setPrefijoSeleccionado] = useState('');
    const [numeroNotaCredito, setNumeroNotaCredito] = useState('');
    const [fechaNotaCredito, setFechaNotaCredito] = useState(ymdLocal());
    const [tipoNotaCredito, setTipoNotaCredito] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCredito, setValorNotaCredito] = useState('');
    const [motivoNotaCredito, setMotivoNotaCredito] = useState('');
    const [loadingNC, setLoadingNC] = useState(false);
    const [notasCreditoExistentes, setNotasCreditoExistentes] = useState([]);
    const [sumaNotasCreditoExistentes, setSumaNotasCreditoExistentes] = useState(0);
    const [ripsAsociadoNc, setRipsAsociadoNc] = useState(null);

    // Modal Ver Recibos
    const [showModalRecibos, setShowModalRecibos] = useState(false);
    const [recibosFactura, setRecibosFactura] = useState([]);

    // Modal Éxito Recibo
    const [showModalExitoRecibo, setShowModalExitoRecibo] = useState(false);
    const [reciboGuardado, setReciboGuardado] = useState(null);

    // Modal Nota Crédito No Electrónica
    const [showModalNotaCreditoNE, setShowModalNotaCreditoNE] = useState(false);
    const [tipoNotaCreditoNE, setTipoNotaCreditoNE] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCreditoNE, setValorNotaCreditoNE] = useState('');
    const [motivoNotaCreditoNE, setMotivoNotaCreditoNE] = useState('');
    const [fechaNotaCreditoNE, setFechaNotaCreditoNE] = useState(ymdLocal());
    const [consecutivoNCNE, setConsecutivoNCNE] = useState(null); // Datos del consecutivo
    const [loadingNCNE, setLoadingNCNE] = useState(false);

    // Dropdown Nueva Factura
    const [showDropdownFactura, setShowDropdownFactura] = useState(false);

    // Dropdown acciones barra superior
    const [showDropdownAcciones, setShowDropdownAcciones] = useState(false);

    // Selección de facturas
    const [facturaSeleccionadaId, setFacturaSeleccionadaId] = useState(null);

    // Modal Completar Datos Factura
    const [showModalCompletarDatos, setShowModalCompletarDatos] = useState(false);
    const [facturaCompletarId, setFacturaCompletarId] = useState(null);
    const [showModalRipsPostFactura, setShowModalRipsPostFactura] = useState(false);
    const [ripsDataPostFactura, setRipsDataPostFactura] = useState(null);

    // Modal Debug - Para mostrar respuestas de DIAN
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState(''); // 'success', 'error'

    // 🔒 Función helper para validar permisos
    const tienePermiso = (permiso) => {
        const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
        return userdata.up && userdata.up.includes(permiso);
    };

    // --- NUEVA LÓGICA DE ACCIONES Y STATS ---
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [facturaAccion, setFacturaAccion] = useState(null);

    // Cooldown para comprobar estado DIAN (evitar clicks excesivos)
    const [comprobandoEstadoDian, setComprobandoEstadoDian] = useState(false);
    const [ultimaComprobacionDian, setUltimaComprobacionDian] = useState({});
    const COOLDOWN_COMPROBACION_MS = 30000; // 30 segundos entre comprobaciones por factura
    const MSG_NC_YA_REGISTRADA = 'Esta factura ya tiene Nota Crédito electrónica registrada. Actualice el listado. Si acaba de enviar una NC y la DIAN presenta demoras, espere un rato para visualizar los cambios.';

    const reconciliarNcAlAbrirModal = async (factura, notas, userdata) => {
        if (!notas || notas.length === 0) {
            return { continuar: true, notas: [] };
        }
        try {
            const syncRes = await axios.post(`/nota-credito/sincronizar-estado/${factura.id}?uid=${userdata.user_id}`);
            const data = syncRes.data || {};
            if (data.estado_actualizado) {
                return { continuar: false, sincronizado: true, message: data.message };
            }
            const notasRestantes = data.notas || [];
            if (data.puede_reenviar && notasRestantes.length === 0) {
                return { continuar: true, notas: [] };
            }
            if (parseInt(data.nuevo_estado, 10) === 3) {
                return { continuar: false, yaAnulada: true };
            }
            return { continuar: false, bloqueado: true, notas: notasRestantes.length ? notasRestantes : notas };
        } catch (error) {
            console.warn('Error sincronizando NC:', error);
            return { continuar: false, bloqueado: true, notas };
        }
    };

    const handleAbrirAcciones = (factura) => {
        setFacturaAccion(factura);
        setShowModalAcciones(true);
    };

    /**
     * Comprobar estado de factura en DIAN (estado 6 - En proceso / error DIAN).
     * @param {number} facturaId
     * @param {{ silencioso?: boolean, forzar?: boolean }} options
     *   silencioso: no muestra alert/modal (para flujo anular)
     *   forzar: omite cooldown
     * @returns {Promise<{success:boolean, encontrada_en_dian?:boolean|null, puede_anular_local?:boolean, nuevo_estado?:number, message?:string, uuid?:string}|null>}
     */
    const comprobarEstadoDian = async (facturaId, options = {}) => {
        const { silencioso = false, forzar = false } = options;
        const ahora = Date.now();
        const ultimaComprobacion = ultimaComprobacionDian[facturaId] || 0;
        const tiempoRestante = Math.ceil((COOLDOWN_COMPROBACION_MS - (ahora - ultimaComprobacion)) / 1000);

        if (!forzar && ahora - ultimaComprobacion < COOLDOWN_COMPROBACION_MS) {
            if (!silencioso) {
                alert(`Por favor espere ${tiempoRestante} segundos antes de volver a comprobar esta factura.`);
            }
            return {
                success: false,
                encontrada_en_dian: null,
                puede_anular_local: false,
                message: `Espere ${tiempoRestante}s antes de volver a comprobar.`,
                cooldown: true,
            };
        }

        setComprobandoEstadoDian(true);
        setUltimaComprobacionDian(prev => ({ ...prev, [facturaId]: ahora }));

        try {
            const response = await axios.post(`/factura/${facturaId}/comprobar-estado-dian`);
            const data = response.data || {};

            if (data.success) {
                if (!silencioso) {
                    const detalle = data.uuid ? `\nCUFE: ${data.uuid}` : '';
                    alert((data.message || 'Estado actualizado correctamente') + detalle);
                    cargarFacturas();
                }
                return {
                    success: true,
                    encontrada_en_dian: data.encontrada_en_dian !== false,
                    puede_anular_local: false,
                    nuevo_estado: data.nuevo_estado,
                    message: data.message,
                    uuid: data.uuid,
                };
            }

            if (!silencioso) {
                setDebugType('error');
                setDebugData({
                    titulo: 'Resultado consulta DIAN',
                    message: (data.message || 'No se pudo confirmar el estado.') +
                        '\n\nSi la factura existe en la DIAN, intente de nuevo en unos minutos. Si no existe, use "Reenviar a DIAN" o anule tras verificar.',
                    response: data.debug?.respuesta || null,
                    json_enviado: data.debug?.consulta || null
                });
                setShowModalDebug(true);
            }

            return {
                success: false,
                encontrada_en_dian: data.encontrada_en_dian === true ? true : (data.encontrada_en_dian === false ? false : null),
                puede_anular_local: data.puede_anular_local === true,
                message: data.message,
            };
        } catch (error) {
            if (!silencioso) {
                setDebugType('error');
                setDebugData({
                    titulo: 'Error al consultar DIAN',
                    message: (error.response?.data?.message || 'Error de conexión con el servidor.') +
                        '\n\nVerifique su conexión e intente de nuevo.',
                    response: error.response?.data || null
                });
                setShowModalDebug(true);
            }
            console.error('Error comprobando estado DIAN:', error);
            return {
                success: false,
                encontrada_en_dian: null,
                puede_anular_local: false,
                message: error.response?.data?.message || error.message,
            };
        } finally {
            setComprobandoEstadoDian(false);
        }
    };

    const cargarFacturasAsync = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaPaciente) params.append('busqueda_paciente', busquedaPaciente);
        if (busquedaDocumento) params.append('busqueda_documento', busquedaDocumento);
        if (numeroFactura) params.append('numero_factura', numeroFactura);
        if (tipoFacturaFiltro) params.append('tipo_factura', tipoFacturaFiltro);
        if (metodoPagoFiltro) params.append('forma_pago', metodoPagoFiltro);

        return axios.get('/facturas?' + params.toString())
            .then(response => {
                if (response.status === 200) {
                    setFacturas(response.data);
                    return response.data;
                }
                return [];
            })
            .catch(error => {
                console.log('err: ' + error);
                return [];
            });
    };

    const esFacturaContado = (f) => (f?.tipo_pago || '').toLowerCase() === 'contado';

    /** Misma regla que la tabla (tipo o estados 4/5 no electrónica). */
    const esFacturaNoElectronica = (f) =>
        f.tipo_factura === 'no_electronica' || [4, 5].includes(parseInt(f.estado, 10));

    const esBorradorFacturaElectronica = (f) => {
        if (esFacturaNoElectronica(f)) return false;
        const numero = String(f.numero_factura ?? '').trim();
        return numero === '' || numero === '0';
    };

    const etiquetaNumeroFactura = (f) => {
        if (esBorradorFacturaElectronica(f)) {
            return 'Borrador#';
        }
        return `#${f.numero_factura || f.id}`;
    };

    const getValorTotalNum = (f) => parseFloat(f?.valor_total || 0) || 0;

    /** Saldo pendiente; si no viene, se asume el total. El string "0" se interpreta como 0, no como falsy que dispare || total. */
    const getSaldoPendienteNum = (f) => {
        const raw = f?.valor_pendiente;
        if (raw === null || raw === undefined || raw === '') return getValorTotalNum(f);
        const p = parseFloat(raw);
        return Number.isFinite(p) ? p : getValorTotalNum(f);
    };

    /** NC tipo total: contado = valor total de la factura (anulación completa); crédito = saldo pendiente. */
    const getImporteNcTipoTotal = (f) =>
        esFacturaContado(f) ? getValorTotalNum(f) : getSaldoPendienteNum(f);

    const facturasParaVista = useMemo(() => {
        let resultado = [...facturas];
        
        // Filtro de vencidas si aplica (desde URL)
        if (filtroUrlActivo === 'vencidas') {
            const hoy = new Date();
            hoy.setHours(0, 0, 0, 0);
            resultado = resultado.filter((f) => {
                if (!f.fecha_vence) return false;
                const fv = new Date(f.fecha_vence);
                if (Number.isNaN(fv.getTime())) return false;
                fv.setHours(0, 0, 0, 0);
                return fv < hoy;
            });
        }

        // Filtro ESTADO FACTURA
        if (estadoFacturaFiltro) {
            resultado = resultado.filter((f) => {
                const est = parseInt(f.estado, 10);
                const saldo = parseFloat(f.valor_pendiente || 0);
                
                switch (estadoFacturaFiltro) {
                    case 'cobrada':
                        // Estados 1, 4 siempre + Estados 2, 5, 6 solo si valor_pendiente = 0
                        if ([1, 4].includes(est)) return true;
                        if ([2, 5, 6].includes(est) && saldo <= 0) return true;
                        return false;
                    case 'por_cobrar':
                        // Estados 2, 5, 6 solo si valor_pendiente > 0
                        return [2, 5, 6].includes(est) && saldo > 0;
                    case 'anulada':
                        return est === 3;
                    case 'borrador':
                        return [0, 7].includes(est);
                    default:
                        return true;
                }
            });
        }

        // Filtro ESTADO DIAN (solo aplica a facturas electrónicas)
        if (estadoDianFiltro) {
            resultado = resultado.filter((f) => {
                const est = parseInt(f.estado, 10);
                
                switch (estadoDianFiltro) {
                    case 'enviada':
                        return [1, 2].includes(est);
                    case 'no_enviada':
                        return [0, 6, 7].includes(est);
                    case 'en_proceso':
                        return est === 6;
                    case 'borrador_dian':
                        return [0, 7].includes(est);
                    default:
                        return true;
                }
            });
        }
        
        // Ordenar: 1° por número de factura (desc), 2° por fecha de emisión (desc)
        resultado.sort((a, b) => {
            // Extraer número de factura (puede ser string con prefijo)
            const numA = parseInt(String(a.numero_factura || '0').replace(/\D/g, '')) || 0;
            const numB = parseInt(String(b.numero_factura || '0').replace(/\D/g, '')) || 0;
            
            // Primero comparar por número de factura (descendente)
            if (numB !== numA) return numB - numA;
            
            // Si son iguales, comparar por fecha de emisión (descendente)
            const fechaA = new Date(a.fecha_emision || 0).getTime();
            const fechaB = new Date(b.fecha_emision || 0).getTime();
            return fechaB - fechaA;
        });
        
        return resultado;
    }, [facturas, filtroUrlActivo, estadoFacturaFiltro, estadoDianFiltro]);

    const totales = {
        total: facturasParaVista.filter(f => f.estado !== 3).reduce((sum, f) => sum + parseFloat(f.valor_total || 0), 0),
        recaudado: facturasParaVista.filter(f => f.estado !== 3).reduce((sum, f) => sum + (parseFloat(f.valor_total || 0) - parseFloat(f.valor_pendiente || 0)), 0),
        pendiente: facturasParaVista.filter(f => f.estado !== 3).reduce((sum, f) => sum + parseFloat(f.valor_pendiente || 0), 0),
        anuladas: facturasParaVista.filter(f => f.estado === 3).length,
        conteo: facturasParaVista.length
    };

    useEffect(() => {
        // Validar permisos primero
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Verificar si tiene permiso para ver listado de facturas
        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_facturas');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const hoy = new Date();
        const diaSemana = hoy.getDay();
        const inicioSemana = new Date(hoy);
        inicioSemana.setDate(hoy.getDate() - diaSemana);
        const finSemana = new Date(inicioSemana);
        finSemana.setDate(inicioSemana.getDate() + 6);
        setFechaInicio(ymdLocal(inicioSemana));
        setFechaFin(ymdLocal(finSemana));

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar usuarios del cliente (incluyendo inactivos para mostrar nombres en facturas históricas)
        axios.get('/users-by-client?uid=' + userdata.user_id + '&incluir_inactivos=true')
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Pacientes + empresas (tipo_cliente=1): el listado de facturas debe resolver nombre para ambos
        // Incluye pacientes con tipo_cliente NULL (datos de migración) que se tratan como pacientes normales
        Promise.all([
            axios.get('/pacientes', { params: { uid: userdata.user_id, incluir_todos: true } }),
            axios.get('/pacientes', { params: { uid: userdata.user_id, solo_empresas: true } })
        ])
            .then(([respPacientes, respEmpresas]) => {
                const listaPacientes = Array.isArray(respPacientes.data) ? respPacientes.data : [];
                const listaEmpresas = Array.isArray(respEmpresas.data) ? respEmpresas.data : [];
                const combinados = [...listaPacientes, ...listaEmpresas];
                const unicos = Array.from(new Map(combinados.map(item => [item.id, item])).values());
                setPacientes(unicos);
            })
            .catch(error => {
                console.log('err: ' + error);
            });

    }, []);

    /** HashRouter: query en `#/ruta?filtro=...`; si no, `window.location.search` (BrowserRouter). */
    const queryStringDesdeUrl = () => {
        const hash = window.location.hash || '';
        const i = hash.indexOf('?');
        if (i !== -1) return hash.slice(i);
        const s = window.location.search;
        return s && s.length > 1 ? s : '';
    };

    useEffect(() => {
        if (!hasPermission) return;
        const filtro = new URLSearchParams(queryStringDesdeUrl()).get('filtro');
        const fin = new Date();
        const finStr = ymdLocal(fin);

        if (filtro === 'vencidas') {
            const inicio = new Date();
            inicio.setFullYear(inicio.getFullYear() - 5);
            setFechaInicio(ymdLocal(inicio));
            setFechaFin(finStr);
            setEstadoFacturaFiltro('por_cobrar');
            setFiltroUrlActivo('vencidas');
        } else if (filtro === 'pendientes') {
            const inicio = new Date();
            inicio.setFullYear(inicio.getFullYear() - 2);
            setFechaInicio(ymdLocal(inicio));
            setFechaFin(finStr);
            setEstadoDianFiltro('no_enviada');
            setFiltroUrlActivo('pendientes');
        } else {
            setFiltroUrlActivo(null);
        }
    }, [hasPermission, location]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            cargarFacturas();
        }
    }, [loggedIn, fechaInicio, fechaFin, usuarioFiltro, estadoFacturaFiltro, estadoDianFiltro, tipoFacturaFiltro, metodoPagoFiltro, numeroFactura]);

    // Cuando se selecciona un Estado DIAN diferente de "Todas", forzar Tipo Factura a "Electrónica"
    useEffect(() => {
        if (estadoDianFiltro && estadoDianFiltro !== '') {
            setTipoFacturaFiltro('electronica');
        }
    }, [estadoDianFiltro]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            const timeoutId = setTimeout(() => {
                cargarFacturas();
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [busquedaPaciente, busquedaDocumento, numeroFactura]);

    const cargarFacturas = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaPaciente) params.append('busqueda_paciente', busquedaPaciente);
        if (busquedaDocumento) params.append('busqueda_documento', busquedaDocumento);
        if (numeroFactura) params.append('numero_factura', numeroFactura);
        if (tipoFacturaFiltro) params.append('tipo_factura', tipoFacturaFiltro);
        if (metodoPagoFiltro) params.append('forma_pago', metodoPagoFiltro);

        // Los filtros de ESTADO FACTURA y ESTADO DIAN se aplican en el frontend (facturasParaVista)
        // porque requieren lógica combinada con valor_pendiente

        axios.get('/facturas?' + params.toString())
            .then(response => {
                if (response.status === 200) {
                    setFacturas(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    /** Nombre para mostrar: persona (nombres+apellidos) o empresa (razón social suele ir en primer_nombre u otros campos). */
    const getNombreMostrarCliente = (p) => {
        if (!p) return '';
        const nombrePersona = `${p.primer_nombre || ''} ${p.segundo_nombre || ''} ${p.primer_apellido || ''} ${p.segundo_apellido || ''}`.trim();
        return nombrePersona || p.razon_social || p.nombre_empresa || p.nombre_comercial || p.nombre || '';
    };

    const getNombrePaciente = (pacienteId) => {
        if (pacienteId == null || pacienteId === '') return 'N/A';
        const paciente = pacientes.find(p => p.id == pacienteId);
        if (!paciente) return 'N/A';
        const s = getNombreMostrarCliente(paciente).trim();
        return s || 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id == usuarioId); // Usar == en lugar de === para comparación flexible
        return usuario ? usuario.name : 'N/A';
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Cobrada';
            case 2: return 'Por Cobrar';
            case 3: return 'Anulada';
            case 4: return 'Cobrada';
            case 5: return 'Por Cobrar';
            case 6: return 'En proceso';
            case 7: return 'Borrador RIPS';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 0: return 'badge badge-outline-secondary';
            case 1: return 'badge badge-outline-success';
            case 2: return 'badge badge-outline-warning';
            case 3: return 'badge badge-outline-danger';
            case 4: return 'badge badge-outline-success';
            case 5: return 'badge badge-outline-warning';
            case 6: return 'badge badge-outline-info'; // En proceso
            case 7: return 'badge badge-outline-info';
            default: return 'badge badge-outline-secondary';
        }
    };

    // Badges "pill" suaves para un look premium (especialmente Borrador RIPS).
    const getEstadoBadgeStyle = (estado) => {
        switch (estado) {
            case 7: // Borrador RIPS
                return { background: 'rgba(23, 162, 184, 0.08)', color: '#17a2b8', border: '1px solid rgba(23, 162, 184, 0.22)', borderRadius: '10px' };
            case 1: // Cobrada
            case 4:
                return { background: 'rgba(40, 167, 69, 0.08)', color: '#28a745', border: '1px solid rgba(40, 167, 69, 0.22)', borderRadius: '10px' };
            case 2: // Por Cobrar
            case 5:
                return { background: 'rgba(250, 173, 20, 0.10)', color: '#faad14', border: '1px solid rgba(250, 173, 20, 0.22)', borderRadius: '10px' };
            case 3: // Anulada
                return { background: 'rgba(220, 53, 69, 0.08)', color: '#dc3545', border: '1px solid rgba(220, 53, 69, 0.22)', borderRadius: '10px' };
            case 6: // En proceso
                return { background: 'rgba(23, 162, 184, 0.08)', color: '#17a2b8', border: '1px solid rgba(23, 162, 184, 0.22)', borderRadius: '10px' };
            case 0: // Generada
            default:
                return { background: 'rgba(108, 117, 125, 0.08)', color: '#6c757d', border: '1px solid rgba(108, 117, 125, 0.22)', borderRadius: '10px' };
        }
    };

    /** Mensajes de API para el cliente: quita códigos numéricos de estado internos (p. ej. "estado 3", "estado_actual: 7"). */
    const mensajeClienteSinCodigoEstado = (msg) => {
        if (msg == null) return '';
        let s = String(msg);
        s = s.replace(/\bestado_actual\s*[:=]\s*\d+/gi, '');
        s = s.replace(/\bestado\s*[:=]\s*\d+/gi, '');
        s = s.replace(/\bestado\s+\d+\b/gi, '');
        s = s.replace(/\ben estado\s+\d+\b/gi, 'en el estado actual');
        s = s.replace(/\(\s*estado\s*\d+\s*\)/gi, '');
        s = s.replace(/[,\s]+([,.])/g, '$1');
        s = s.replace(/\s{2,}/g, ' ').replace(/^[\s,;:.-]+|[\s,;:.-]+$/g, '').trim();
        return s || 'Operación no completada. Intente de nuevo o contacte soporte.';
    };

    const abrirModalRecibo = (factura) => {
        setFacturaSeleccionada(factura);
        setValorRecibo('');
        setMedioPago('10');
        setFechaPago(ymdLocal());
        setObservacionesRecibo('');
        setShowModalRecibo(true);
    };

    const handleValorReciboChange = (e) => {
        const digits = e.target.value.replace(/\D/g, '');
        if (digits === '') {
            setValorRecibo('');
            return;
        }
        const num = parseInt(digits, 10);
        setValorRecibo(Number.isFinite(num) ? num.toLocaleString('es-CO') : '');
    };

    const guardarRecibo = async () => {
        const valorPendiente = facturaSeleccionada.valor_pendiente || facturaSeleccionada.valor_total;
        const montoRecibo = parseMontoRecibo(valorRecibo);

        if (!montoRecibo || montoRecibo <= 0) {
            alert('Ingrese un valor válido');
            return;
        }

        if (montoRecibo > parseFloat(valorPendiente)) {
            alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(parseFloat(valorPendiente)).toLocaleString('es-CO')}`);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const reciboData = {
            factura_id: facturaSeleccionada.id,
            valor_recibido: montoRecibo,
            medio_pago: medioPago,
            fecha_pago: fechaPago,
            observaciones: observacionesRecibo
        };

        try {
            const response = await axios.post('/recibo-caja', reciboData);
            if (response.status === 200 || response.status === 201) {
                setShowModalRecibo(false);
                setReciboGuardado(response.data);
                setShowModalExitoRecibo(true);
                cargarFacturas();
            }
        } catch (error) {
            alert('Error al registrar el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const abrirInformacionFactura = (facturaId) => {
        const prefix = getSpaPathPrefix();
        const url = `${window.location.origin}${prefix}/#/informacion-factura/${facturaId}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    /**
     * Descarte directo (sin modal de nota crédito): borrador FEV / borrador RIPS.
     * Estado 6 (error DIAN) usa anularFacturaErrorDian (verificar DIAN primero).
     */
    const anularFacturaSimple = async (factura, { skipConfirm = false } = {}) => {
        const est = parseInt(factura.estado, 10);
        const esBorradorFev = esBorradorFacturaElectronica(factura);
        const esBorradorRips = est === 7;
        const esBorrador = esBorradorRips || esBorradorFev;

        let mensaje = '¿Está seguro de anular esta factura?';
        if (esBorradorRips) {
            mensaje = 'Se borrará por completo la factura y el RIPS. ¿Desea Continuar?';
        } else if (esBorradorFev) {
            mensaje = '¿Eliminar este borrador de factura?\n\nSe borrará por completo. No quedará registro.';
        } else if (est === 6) {
            mensaje = '¿Anular localmente esta factura?\n\nNo se encontró emitida en la DIAN.';
        }

        if (!skipConfirm && !window.confirm(mensaje)) return;

        try {
            const response = await axios.put(`/factura/${factura.id}/estado`, { estado: 3 });
            if (response.status === 200 || response.data?.success) {
                const okMsg = mensajeClienteSinCodigoEstado(
                    response.data?.message
                    || (esBorradorRips
                        ? 'Borrador Rips y Factura Eliminados Exitosamente'
                        : (esBorrador ? 'Borrador eliminado correctamente.' : 'La factura fue anulada correctamente.'))
                );
                alert(okMsg);
                cargarFacturas();
            }
        } catch (error) {
            const detalle = mensajeClienteSinCodigoEstado(
                error.response?.data?.message || error.response?.data?.error || error.message
            );
            alert(
                (esBorrador ? 'No se pudo eliminar el borrador. ' : 'No se pudo anular la factura. ')
                + (detalle ? detalle : 'Intente de nuevo o contacte soporte.')
            );
        }
    };

    /**
     * Error DIAN (estado 6): verificar en DIAN antes de anular.
     * - Si está en DIAN → actualiza estado y abre modal Nota Crédito.
     * - Si no está → permite anulación local.
     * - Si la consulta falla → no anula.
     */
    const anularFacturaErrorDian = async (factura) => {
        const ok = window.confirm(
            'Antes de anular se verificará en la DIAN si la factura ya fue emitida.\n\n'
            + '• Si está en DIAN: se actualiza el estado y podrá anular con Nota Crédito.\n'
            + '• Si no está en DIAN: se podrá anular localmente.\n\n'
            + '¿Continuar con la verificación?'
        );
        if (!ok) return;

        const resultado = await comprobarEstadoDian(factura.id, { silencioso: true, forzar: true });

        if (resultado?.cooldown) {
            alert(resultado.message || 'Espere un momento antes de volver a comprobar.');
            return;
        }

        if (resultado?.encontrada_en_dian || resultado?.success) {
            const lista = await cargarFacturasAsync();
            const actualizada = (lista || []).find((f) => String(f.id) === String(factura.id))
                || {
                    ...factura,
                    estado: resultado.nuevo_estado ?? (esFacturaContado(factura) ? 1 : 2),
                };

            alert(
                (resultado.message || 'La factura sí está emitida en la DIAN. Estado actualizado.')
                + (resultado.uuid ? `\nCUFE: ${resultado.uuid}` : '')
                + '\n\nA continuación puede generar la Nota Crédito para anularla ante la DIAN.'
            );
            await abrirModalNotaCredito(actualizada);
            return;
        }

        if (resultado?.puede_anular_local && resultado?.encontrada_en_dian === false) {
            const confirmarLocal = window.confirm(
                (resultado.message || 'No se encontró la factura emitida en la DIAN.')
                + '\n\n¿Anularla localmente? (No afectará a la DIAN porque no está emitida allí.)'
            );
            if (!confirmarLocal) return;
            await anularFacturaSimple({ ...factura, estado: 6 }, { skipConfirm: true });
            return;
        }

        alert(
            (resultado?.message || 'No se pudo verificar el estado en la DIAN.')
            + '\n\nNo se anula la factura. Use "Actualizar Estado" o reintente más tarde.'
        );
    };

    const getEtiquetaAccionAnular = (factura) => {
        const est = parseInt(factura?.estado, 10);
        if ([1, 2].includes(est) && !esFacturaNoElectronica(factura)) {
            return {
                texto: 'Generar Nota Crédito',
                icono: 'fa-file-invoice',
                clase: 'text-danger',
            };
        }
        if (est === 7) {
            return {
                texto: 'Eliminar Borrador',
                icono: 'fa-trash-alt',
                clase: 'text-danger',
            };
        }
        if (esBorradorFacturaElectronica(factura)) {
            return {
                texto: 'Eliminar borrador',
                icono: 'fa-trash-alt',
                clase: 'text-danger',
            };
        }
        if (est === 6) {
            return {
                texto: 'Verificar DIAN y anular',
                icono: 'fa-search',
                clase: 'text-danger',
            };
        }
        return {
            texto: 'Anular Factura',
            icono: 'fa-ban',
            clase: 'text-danger',
        };
    };

    /**
     * Desde el menú de acciones: NC electrónica, NC no electrónica o anulación simple según estado/tipo.
     */
    const abrirFlujoAnularFactura = (factura) => {
        const est = parseInt(factura.estado, 10);
        if (est === 6) {
            anularFacturaErrorDian(factura);
            return;
        }
        if ([0, 7].includes(est)) {
            anularFacturaSimple(factura);
            return;
        }
        if (esFacturaNoElectronica(factura)) {
            abrirModalNotaCreditoNoElectronica(factura);
            return;
        }
        abrirModalNotaCredito(factura);
    };

    const abrirModalNotaCredito = async (factura) => {
        setFacturaSeleccionada(factura);
        setPrefijoSeleccionado('');
        setNumeroNotaCredito('');
        setTipoNotaCredito('total');
        setValorNotaCredito(getImporteNcTipoTotal(factura));
        setMotivoNotaCredito('');
        setNotasCreditoExistentes([]);
        setSumaNotasCreditoExistentes(0);
        setRipsAsociadoNc(
            parseInt(factura?.estadorips, 10) === 1
                ? { tiene_rips: true, cantidad: 0, tiene_enviado_sispro: false, items: [] }
                : null
        );

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const [prefijosRes, ncRes] = await Promise.all([
                axios.get('/parametros-fev?uid=' + userdata.user_id),
                axios.get(`/nota-credito/por-factura/${factura.id}?uid=${userdata.user_id}`),
            ]);

            if (prefijosRes.status === 200) {
                const prefijosFiltrados = prefijosRes.data.filter(param =>
                    param.tipo === 'Nota Credito' &&
                    param.users_id == factura.users_id &&
                    param.estado == 1
                );
                setPrefijos(prefijosFiltrados);
            }

            if (ncRes.status === 200) {
                const notas = ncRes.data?.notas || [];
                setNotasCreditoExistentes(notas);
                setSumaNotasCreditoExistentes(parseFloat(ncRes.data?.suma_valor || 0));

                const rips = ncRes.data?.rips;
                if (rips?.tiene_rips || (rips?.cantidad || 0) > 0) {
                    setRipsAsociadoNc(rips);
                } else if (parseInt(factura?.estadorips, 10) !== 1) {
                    setRipsAsociadoNc(null);
                }

                if (notas.length > 0) {
                    const sync = await reconciliarNcAlAbrirModal(factura, notas, userdata);
                    if (sync.sincronizado) {
                        alert(sync.message || 'Se actualizó el estado de la factura según la NC registrada.');
                        cargarFacturas();
                        return;
                    }
                    if (sync.yaAnulada) {
                        alert('Esta factura ya está anulada. Actualice el listado.');
                        cargarFacturas();
                        return;
                    }
                    if (sync.continuar) {
                        setNotasCreditoExistentes([]);
                        setSumaNotasCreditoExistentes(0);
                    } else if (sync.bloqueado) {
                        if (sync.notas?.length) {
                            setNotasCreditoExistentes(sync.notas);
                        }
                        alert(MSG_NC_YA_REGISTRADA);
                        return;
                    }
                }
            }
        } catch (error) {
            console.log('Error cargando datos de nota crédito:', error);
        }

        setShowModalNotaCredito(true);
    };

    const handlePrefijoChange = (e) => {
        const prefijoId = e.target.value;
        setPrefijoSeleccionado(prefijoId);

        if (prefijoId) {
            const prefijo = prefijos.find(p => p.id == prefijoId);
            if (prefijo) {
                setNumeroNotaCredito(prefijo.numero_factura);
            }
        } else {
            setNumeroNotaCredito('');
        }
    };

    const abrirCompletarDatos = (facturaId) => {
        setFacturaCompletarId(facturaId);
        setShowModalCompletarDatos(true);
    };

    const construirRipsDataDesdeFactura = async (facturaId, ripsIdHint, facturaHint) => {
        let ripsId = ripsIdHint || null;
        let factura = facturaHint || null;

        try {
            if (!factura) {
                const factRes = await axios.get(`/factura/${facturaId}`);
                factura = factRes.data;
            }
            if (!ripsId) {
                const ncRes = await axios.get(`/nota-credito/por-factura/${facturaId}`);
                ripsId = ncRes.data?.rips?.items?.[0]?.id || null;
            }
        } catch (e) {
            console.error('Error cargando RIPS post-factura:', e);
            return null;
        }

        if (!ripsId || !factura) return null;

        let pacienteNombre = '';
        let pacienteTipoDoc = '';
        let pacienteNumeroDoc = '';
        let profesionalNombre = '';
        try {
            if (factura.paciente_id) {
                const pacRes = await axios.get('/paciente', { params: { id: factura.paciente_id } });
                const p = Array.isArray(pacRes.data) ? pacRes.data[0] : pacRes.data;
                if (p) {
                    pacienteNombre = `${p.primer_nombre || ''} ${p.segundo_nombre || ''} ${p.primer_apellido || ''} ${p.segundo_apellido || ''}`.trim()
                        || p.nombre_paciente
                        || '';
                    pacienteTipoDoc = p.tipo_documento || '';
                    pacienteNumeroDoc = p.numero_documento || '';
                }
            }
            if (factura.users_id) {
                const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
                const uRes = await axios.get(`/usuarios?uid=${userdata.user_id}`);
                const users = Array.isArray(uRes.data) ? uRes.data : [];
                const prof = users.find((u) => String(u.id) === String(factura.users_id));
                if (prof) {
                    profesionalNombre = `${prof.name || ''} ${prof.lastname || ''}`.trim();
                }
            }
        } catch (e) {
            // Modal puede seguir con ids; nombres son opcionales
        }

        const estadoFactura = parseInt(factura.estado, 10);
        // Tras envío DIAN exitoso suele quedar 1/2; si el hint aún trae 7, forzar contado DIAN
        const facturaEstadoModal = [0, 7].includes(estadoFactura) ? 1 : estadoFactura;

        return {
            rips_id: ripsId,
            factura_id: Number(facturaId),
            factura_estado: facturaEstadoModal,
            factura_tipo_factura: factura.tipo_factura || 'electronica',
            factura_prefijo: factura.prefijo || null,
            factura_numero: factura.numero_factura || null,
            factura_etiqueta: getEtiquetaFactura(factura.prefijo, factura.numero_factura, facturaId),
            users_id: factura.users_id,
            tipo: 'fev',
            estado: 1,
            fecha: factura.fecha_emision,
            paciente_id: factura.paciente_id,
            paciente_nombre: pacienteNombre,
            paciente_tipo_doc: pacienteTipoDoc,
            paciente_numero_doc: pacienteNumeroDoc,
            profesional_nombre: profesionalNombre,
            titulo_modal: 'Factura enviada — gestione el RIPS',
            subtitulo_modal: 'Puede descargar o enviar el RIPS a SISPRO sin salir de facturación',
        };
    };

    const handleCompletarDatosSuccess = async (result = {}) => {
        setShowModalCompletarDatos(false);
        const facturaId = result.facturaId || facturaCompletarId;
        setFacturaCompletarId(null);
        cargarFacturas();

        if (result.abrirRips && facturaId) {
            const ripsData = await construirRipsDataDesdeFactura(
                facturaId,
                result.ripsId,
                result.factura
            );
            if (ripsData) {
                setRipsDataPostFactura(ripsData);
                setShowModalRipsPostFactura(true);
            } else {
                alert('La factura se completó, pero no se encontró el RIPS asociado. Puede enviarlo desde Indicadores → RIPS.');
            }
        }
    };

    const handleDescargarRipsPostFactura = async (ripsId) => {
        try {
            const response = await axios.get(`/rips/${ripsId}/descargar`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `rips_${ripsId}.json`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            alert('No se pudo descargar el RIPS.');
        }
    };

    const generarNotaCredito = async () => {
        if (loadingNC) return;

        if (!prefijoSeleccionado) {
            alert('Seleccione un prefijo');
            return;
        }

        if (!fechaNotaCredito) {
            alert('Seleccione una fecha');
            return;
        }

        if (!motivoNotaCredito.trim()) {
            alert('Ingrese el motivo de la nota crédito');
            return;
        }

        if (tipoNotaCredito === 'parcial' && esFacturaContado(facturaSeleccionada)) {
            alert('La nota crédito parcial aplica solo a facturas a crédito.');
            return;
        }

        if (esFacturaContado(facturaSeleccionada) && notasCreditoExistentes.length > 0) {
            alert(MSG_NC_YA_REGISTRADA);
            return;
        }

        // Validar valor si es parcial (solo crédito)
        if (tipoNotaCredito === 'parcial') {
            const valor = parseFloat(valorNotaCredito);
            const saldoPendiente = getSaldoPendienteNum(facturaSeleccionada);

            if (!valorNotaCredito || valor <= 0) {
                alert('Ingrese un valor válido para la nota crédito');
                return;
            }

            if (valor > saldoPendiente) {
                alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(saldoPendiente).toLocaleString('es-CO')}`);
                return;
            }
        }

        let mensajeConfirmacion = tipoNotaCredito === 'total'
            ? '¿Está seguro de generar una Nota Crédito TOTAL? Esta acción no se puede deshacer.\n\nSi la DIAN tarda en responder, no envíe otra NC: espere y actualice el listado.'
            : `¿Está seguro de generar una Nota Crédito PARCIAL por $${Math.round(parseFloat(valorNotaCredito)).toLocaleString('es-CO')}? Esta acción no se puede deshacer.`;

        if (ripsAsociadoNc?.tiene_rips && tipoNotaCredito === 'total') {
            mensajeConfirmacion += ripsAsociadoNc.tiene_enviado_sispro
                ? '\n\n⚠ Esta factura tiene RIPS ya enviado a SISPRO: al anular, el RIPS quedará anulado en el sistema.'
                : '\n\n⚠ Esta factura tiene RIPS asociado: al anular se eliminará el RIPS (solo es válido con la FEV enviada).';
        }

        if (!window.confirm(mensajeConfirmacion)) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const notaCreditoData = {
            factura_id: facturaSeleccionada.id,
            parametrosfev_id: prefijoSeleccionado,
            motivo: motivoNotaCredito,
            fecha_emision: fechaNotaCredito,
            tipo: tipoNotaCredito,
            valor: tipoNotaCredito === 'parcial' ? parseFloat(valorNotaCredito) : null
        };

        setLoadingNC(true);
        try {
            const response = await axios.post('/nota-credito/enviar-dian-directo', notaCreditoData);

            setShowModalNotaCredito(false);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: response.data.message,
                    uuid: response.data.uuid,
                    cufe: response.data.uuid,
                    numero_nc: response.data.numero_nc,
                    recibos_anulados: response.data.recibos_anulados,
                    facturaId: facturaSeleccionada.id,
                    pdf_url: response.data.pdf_path || null,
                    xml_url: response.data.xml_path || null,
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    titulo: 'No se pudo completar la Nota Crédito',
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    facturaId: facturaSeleccionada.id
                });
                setShowModalDebug(true);
            }

            cargarFacturas();
            setPrefijoSeleccionado('');
            setNumeroNotaCredito('');
            setFechaNotaCredito(ymdLocal());
            setTipoNotaCredito('total');
            setValorNotaCredito('');
            setMotivoNotaCredito('');
            setNotasCreditoExistentes([]);
            setSumaNotasCreditoExistentes(0);
            setRipsAsociadoNc(null);

        } catch (error) {
            console.error('Error al generar nota crédito:', error);
            setShowModalNotaCredito(false);

            setDebugType('error');
            setDebugData({
                titulo: 'Error al enviar Nota Crédito',
                message: (error.response?.data?.message || error.message)
                    + (error.response?.status === 422 || error.response?.data?.notas_credito_existentes
                        ? ' Actualice el listado antes de reintentar; puede que la primera NC ya se haya registrado.'
                        : ' Si la DIAN tardó, espere unos segundos, recargue el listado y verifique el estado de la factura antes de enviar otra.'),
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data,
                facturaId: facturaSeleccionada.id
            });
            setShowModalDebug(true);
            cargarFacturas();
        } finally {
            setLoadingNC(false);
        }
    };

    const verRecibos = async (factura) => {
        setFacturaSeleccionada(factura);

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente

        try {
            const response = await axios.get(`/recibos-caja/${factura.id}?uid=${userdata.user_id}`);
            if (response.status === 200) {
                setRecibosFactura(response.data);
                setShowModalRecibos(true);
            }
        } catch (error) {
            alert('Error al cargar los recibos: ' + (error.response?.data?.message || error.message));
        }
    };

    const getMedioPagoTexto = (codigo) => getFormaPagoTexto(codigo);

    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor)).toLocaleString('es-CO');
    };

    const anularRecibo = async (reciboId) => {
        if (!window.confirm('¿Está seguro de anular este recibo?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        // Mantener el estado actual según el tipo de factura
        // Estado 2: Por Cobrar (Electrónica) - mantener en 2
        // Estado 5: Por Cobrar (No Electrónica) - mantener en 5
        const estadoDestino = facturaSeleccionada.estado === 5 ? 5 : 2;

        try {
            const response = await axios.put(`/recibo-caja/${reciboId}/anular?uid=${userdata.user_id}`,
                { estado_factura_destino: estadoDestino }
            );
            if (response.status === 200) {
                alert('El recibo fue anulado correctamente.');
                verRecibos(facturaSeleccionada);
                cargarFacturas();
            }
        } catch (error) {
            const detalle = mensajeClienteSinCodigoEstado(
                error.response?.data?.message || error.response?.data?.error || error.message
            );
            alert('No se pudo anular el recibo. ' + (detalle ? detalle : 'Intente de nuevo.'));
        }
    };

    /** Fechas solo-día (YYYY-MM-DD del backend): parsear sin UTC para no mostrar el día anterior. */
    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const s = String(fecha).trim();
        const parte = s.includes('T') ? s.split('T')[0] : s.split(/\s+/)[0];
        const match = parte.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
            return `${match[3]}/${match[2]}/${match[1].slice(-2)}`;
        }
        const date = new Date(fecha);
        if (Number.isNaN(date.getTime())) return '';
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const construirDireccionCompleta = (paciente) => {
        if (!paciente) return '';
        const partes = [];
        if (paciente.direccion) partes.push(paciente.direccion);
        if (paciente.zona) partes.push(paciente.zona);
        if (paciente.nombre_ciudad_residencia) partes.push(paciente.nombre_ciudad_residencia);
        if (paciente.nombre_departamento_residencia) partes.push(paciente.nombre_departamento_residencia);
        if (paciente.nombre_pais_residencia) partes.push(paciente.nombre_pais_residencia);
        return partes.join(', ') || paciente.direccion || '';
    };

    const obtenerNit = (pacienteRef) => {
        if (!pacienteRef) return '';
        return pacienteRef.numero_documento || pacienteRef.numeroDocumento || '';
    };

    const vistaPreviaRecibo = async (recibo) => {
        let paciente = pacientes.find(p => p.id === facturaSeleccionada?.paciente_id);

        // Siempre cargar los datos completos del paciente para asegurar que tenemos todos los campos
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${facturaSeleccionada?.paciente_id}`);
            if (response.data && response.data.length > 0) {
                paciente = response.data[0];
                console.log('Paciente cargado:', paciente);
                console.log('Teléfono:', paciente.telefono);
                console.log('Celular:', paciente.celular);
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = paciente ? getNombreMostrarCliente(paciente) : getNombrePaciente(facturaSeleccionada?.paciente_id);

        // 🆕 Obtener nombre del facturador (usuario que creó la factura)
        const nombreFacturador = facturaSeleccionada?.users_id ? getNombreUsuario(facturaSeleccionada.users_id) : 'N/A';

        // 🆕 BANNER: RECIBO DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBO DE CAJA - FACTURA N° ${facturaSeleccionada?.numero_factura || ''}
                </div>
            </div>
        `;

        // 🆕 Datos del recibo en tabla
        const datosReciboHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">RECIBO #</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${recibo.numero_recibo}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA PAGO</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(recibo.fecha_pago)}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FORMA DE PAGO</td>
                        <td style="background-color: #ffffff; width: 19%; padding: 6px; border: 1px solid #dee2e6;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td colspan="5" style="background-color: #ffffff; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibo = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${bannerHTML}
                    
                    ${datosReciboHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit(paciente)}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(paciente)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Concepto</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="border: 1px solid #dee2e6; padding: 8px; background-color: #ffffff; font-size: 12px;">Abono a Factura N° ${facturaSeleccionada?.numero_factura || ''}</td>
                                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; background-color: #ffffff; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif; white-space: nowrap;">Total:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    ${recibo.observaciones ? `
                    <div style="margin-top: 20px;">
                        <h6 style="font-size: 14px; font-weight: bold;">Observaciones:</h6>
                        <p style="font-size: 12px;">${recibo.observaciones}</p>
                    </div>
                    ` : ''}

                    <div style="margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px;">
                        <p style="color: #666; margin-bottom: 30px; font-size: 12px;">Recibí conforme el valor arriba mencionado</p>
                        <div style="margin-top: 50px;">
                            <div style="border-top: 1px solid #333; width: 200px; margin: 0 auto;"></div>
                            <p style="margin-top: 5px; color: #666; font-size: 12px;">Firma del Paciente</p>
                        </div>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=800,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibo de Caja N° ${recibo.numero_recibo}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibo}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const vistaPreviaRecibos = async () => {
        let paciente = pacientes.find(p => p.id === facturaSeleccionada?.paciente_id);

        // Siempre cargar los datos completos del paciente para asegurar que tenemos todos los campos
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${facturaSeleccionada?.paciente_id}`);
            if (response.data && response.data.length > 0) {
                paciente = response.data[0];
                console.log('Paciente cargado (recibos):', paciente);
                console.log('Teléfono:', paciente.telefono);
                console.log('Celular:', paciente.celular);
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = paciente ? getNombreMostrarCliente(paciente) : getNombrePaciente(facturaSeleccionada?.paciente_id);
        const totalRecibosActivos = recibosFactura.filter(r => r.estado !== 0).reduce((sum, r) => sum + parseFloat(r.valor_pago), 0);

        // 🆕 Obtener nombre del facturador (usuario que creó la factura)
        const nombreFacturador = facturaSeleccionada?.users_id ? getNombreUsuario(facturaSeleccionada.users_id) : 'N/A';

        // 🆕 BANNER: RECIBOS DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBOS DE CAJA - FACTURA N° ${facturaSeleccionada?.numero_factura || ''}
                </div>
            </div>
        `;

        // 🆕 Datos del reporte en tabla
        const datosReporteHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA REPORTE</td>
                        <td style="background-color: #ffffff; width: 35%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(new Date().toISOString())}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td style="background-color: #ffffff; width: 35%; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibos = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${bannerHTML}
                    
                    ${datosReporteHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit(paciente)}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(paciente)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">N° Recibo</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Fecha Pago</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Medio Pago</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: center; font-size: 12px;">Estado</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Observaciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${recibosFactura.map((recibo, index) => `
                                <tr style="background-color: ${index % 2 === 0 ? '#f8f9fa' : '#ffffff'};">
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${recibo.numero_recibo}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${formatearFecha(recibo.fecha_pago)}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px; font-weight: bold;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; text-align: center; font-size: 12px;">
                                        <span style="padding: 4px 8px; border-radius: 3px; font-size: 11px; font-weight: bold; color: white; background: ${recibo.estado === 0 ? '#dc3545' : '#28a745'};">
                                            ${recibo.estado === 0 ? 'Anulado' : 'Activo'}
                                        </span>
                                    </td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${recibo.observaciones || '-'}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-weight: bold; white-space: nowrap;">Total Recibos Activos:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-family: monospace; font-weight: bold;">$${Math.round(totalRecibosActivos).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=900,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibos de Caja - Factura ${facturaSeleccionada?.numero_factura}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibos}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const enviarWhatsAppFactura = async (factura) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        let celularPaciente = '';
        let nombrePaciente = '';

        try {
            // Get patient info
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${factura.paciente_id}`);
            if (response.data && response.data.length > 0) {
                const paciente = response.data[0];
                celularPaciente = paciente.celular || paciente.telefono;
                nombrePaciente = getNombreMostrarCliente(paciente).trim() || 'cliente';
            }
        } catch (error) {
            console.log('Error getting patient info:', error);
            // Fallback if we can't get fresh info (using data from list if available, though list might not have phone)
        }

        if (!celularPaciente) {
            alert('El paciente no tiene número de celular registrado.');
            return;
        }

        const msg = `Hola ${nombrePaciente}, adjunto la factura N° ${factura.numero_factura} por valor de $${Math.round(factura.valor_total).toLocaleString('es-CO')}.`;
        const url = `https://wa.me/57${celularPaciente}?text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');
    };

    const getFacturaSeleccionada = () => {
        return facturasParaVista.find(f => f.id === facturaSeleccionadaId);
    };

    const handleSeleccionFactura = (facturaId) => {
        setFacturaSeleccionadaId(facturaSeleccionadaId === facturaId ? null : facturaId);
    };

    const pagination = useClientPagination(facturasParaVista);

    const cambiarPaginaFacturas = (numeroPagina) => {
        pagination.cambiarPagina(numeroPagina);
        setFacturaSeleccionadaId(null);
    };

    const enviarFacturaDian = async (facturaId, isRetry = false, facturaRow = null) => {
        let msg = isRetry
            ? '¿Está seguro de reintentar el envío de esta factura a la DIAN?'
            : '¿Está seguro de enviar esta factura a la DIAN?';

        const facturaRef = facturaRow || facturas.find((f) => String(f.id) === String(facturaId));
        if (!isRetry && facturaRef && esBorradorFacturaElectronica(facturaRef)) {
            try {
                const prev = await axios.get(`/factura/${facturaId}/proximo-numero-dian`);
                const numeroCompleto = prev.data?.numero_completo
                    || `${prev.data?.prefijo || ''}${prev.data?.proximo_numero || ''}`;
                msg = `Esta factura está en borrador (N° 0). Se asignará el consecutivo ${numeroCompleto} y se enviará a la DIAN. ¿Continuar?`;
            } catch (e) {
                console.warn('No se pudo obtener próximo consecutivo:', e);
                msg = 'Esta factura está en borrador. Se asignará el consecutivo vigente y se enviará a la DIAN. ¿Continuar?';
            }
        }

        if (!window.confirm(msg)) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        try {
            const response = await axios.post(`/factura/${facturaId}/enviar-dian`, {});

            console.log('Respuesta completa de enviar-dian:', response.data);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: response.data.numero_completo
                        ? `Factura N° ${response.data.numero_completo} enviada exitosamente a la DIAN`
                        : 'Factura enviada exitosamente a la DIAN',
                    cufe: response.data.uuid,
                    estado: response.data.estado,
                    numero_factura: response.data.numero_factura,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
                cargarFacturas();
            } else {
                // Cuando success = false, mostrar el error con toda la información
                console.log('Error de DIAN - response.data:', response.data);
                setDebugType('error');
                setDebugData({
                    message: response.data.message || 'Error al enviar a la DIAN',
                    response: response.data.response || response.data.error,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    fullError: response.data,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            const errorData = error.response?.data || {};
            const erroresDian = errorData.response?.document?.errors
                || errorData.response?.errors
                || [];
            const textoErrores = Array.isArray(erroresDian) ? erroresDian.join(' ') : '';
            const yaProcesada = textoErrores.toLowerCase().includes('procesado anteriormente');

            if (yaProcesada) {
                setDebugType('error');
                setDebugData({
                    message: 'Este documento ya fue procesado por la DIAN. Use "Actualizar Estado" para sincronizar, no "Reenviar".',
                    response: errorData.response,
                    json_enviado: errorData.json_enviado,
                    status_code: errorData.status_code,
                    fullError: errorData,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
                return;
            }

            console.error('Error al enviar a DIAN (catch):', error);
            console.log('error.response?.data:', error.response?.data);
            console.log('error.response?.data completo:', JSON.stringify(error.response?.data, null, 2));

            // Construir debugData con toda la información disponible
            const debugErrorData = {
                message: error.response?.data?.message || error.message || 'Error al enviar a la DIAN',
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                status_code: error.response?.status || error.response?.data?.status_code,
                fullError: error.response?.data || error,
                facturaId: facturaId
            };

            console.log('debugData que se va a mostrar:', debugErrorData);

            setDebugType('error');
            setDebugData(debugErrorData);
            setShowModalDebug(true);
        }
    };

    const verJsonPreview = async (facturaId) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente

        try {
            const response = await axios.get(`/factura/${facturaId}/json-dian?uid=${userdata.user_id}`);

            setDebugType('json');
            setDebugData({
                message: 'JSON que se enviará a la DIAN',
                subtitle: `Factura ID: ${facturaId}`,
                json: response.data
            });
            setShowModalDebug(true);
        } catch (error) {
            console.error('Error al generar JSON:', error);
            alert('Error al generar JSON: ' + (error.response?.data?.message || error.message));
        }
    };

    // ==========================================
    // Lógica para Nota Crédito No Electrónica
    // ==========================================

    const abrirModalNotaCreditoNoElectronica = async (factura) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        setFacturaSeleccionada(factura);
        setLoadingNCNE(true);

        try {
            const response = await axios.get('/consecutivo-nc-no-electronica?uid=' + userdata.user_id);
            if (response.data) {
                setConsecutivoNCNE(response.data);

                // Inicializar formulario: contado → valor total; crédito → saldo pendiente
                setTipoNotaCreditoNE('total');
                setValorNotaCreditoNE(getImporteNcTipoTotal(factura));
                setMotivoNotaCreditoNE('');
                setFechaNotaCreditoNE(ymdLocal());

                setShowModalNotaCreditoNE(true);
            } else {
                alert('No se ha configurado un consecutivo para Notas Crédito No Electrónicas. Vaya a Configuración > Administrador Contable.');
            }
        } catch (error) {
            console.error(error);
            alert('Error al obtener consecutivo de Notas Crédito.');
        } finally {
            setLoadingNCNE(false);
        }
    };

    const generarNotaCreditoNE = async (e) => {
        e.preventDefault();

        if (!facturaSeleccionada || !consecutivoNCNE) return;

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const total = getValorTotalNum(facturaSeleccionada);
        const pend = getSaldoPendienteNum(facturaSeleccionada);
        const contado = esFacturaContado(facturaSeleccionada);
        const valorAplicar = parseFloat(valorNotaCreditoNE);

        if (tipoNotaCreditoNE === 'parcial' && contado) {
            alert('La nota crédito parcial aplica solo a facturas a crédito.');
            return;
        }

        const topeMax = contado ? total : pend;

        // Validaciones
        if (valorAplicar <= 0) {
            alert("El valor de la nota crédito debe ser mayor a 0.");
            return;
        }

        if (valorAplicar > topeMax + 100) {
            const etiqueta = contado ? 'el valor total de la factura' : 'el saldo pendiente';
            alert(`El valor de la nota crédito ($${valorAplicar.toLocaleString()}) no puede superar ${etiqueta} ($${Math.round(topeMax).toLocaleString('es-CO')}).`);
            return;
        }

        if (!motivoNotaCreditoNE.trim()) {
            alert("Debe ingresar un motivo para la nota crédito.");
            return;
        }

        if (!window.confirm(`¿Está seguro de generar una Nota Crédito por valor de $${valorAplicar.toLocaleString()}? Esta acción afectará el saldo y el consecutivo.`)) {
            return;
        }

        const data = {
            factura_id: facturaSeleccionada.id,
            valor: valorAplicar,
            motivo: motivoNotaCreditoNE,
            fecha: fechaNotaCreditoNE,
            consecutivo_id: consecutivoNCNE.id,
            tipo_nota: tipoNotaCreditoNE // 'total' o 'parcial'
        };

        setLoadingNCNE(true);

        try {
            const response = await axios.post('/nota-credito-no-electronica?uid=' + userdata.user_id, data);

            if (response.data.success) {
                alert('Nota Crédito generada exitosamente: ' + response.data.numero_nota);
                setShowModalNotaCreditoNE(false);
                cargarFacturas(); // Recargar lista
            } else {
                alert(
                    'No se pudo generar la nota crédito. ' +
                    mensajeClienteSinCodigoEstado(response.data?.message || '')
                );
            }

        } catch (error) {
            console.error(error);
            alert(
                'No se pudo generar la Nota Crédito. ' +
                mensajeClienteSinCodigoEstado(error.response?.data?.message || error.message)
            );
        } finally {
            setLoadingNCNE(false);
        }
    };

    if (loggedIn) {
        return (
            <div className="wrapper" style={{ fontSize: '13px' }}>
                <style>{`
                    .summary-card { background: #fff; padding: 1.25rem; border-radius: 12px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); border: none; transition: transform 0.2s; height: 100%; }
                    .summary-card:hover { transform: translateY(-5px); }
                    .icon-box { width: 45px; height: 45px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; margin-right: 15px; }
                    .card-label { color: #8c8c8c; font-size: 0.75rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
                    .card-value { font-size: 1.25rem; font-weight: 700; color: #323a45; }
                    .card-subtext { font-size: 0.65rem; color: #bababa; margin-top: 2px; }
                    .filter-card { background: #fff; border-radius: 12px; border: none; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05); }
                    .filter-card .form-control,
                    .filter-card select.form-control {
                        height: 38px;
                        min-height: 38px;
                        box-sizing: border-box;
                        padding: 0.375rem 0.75rem;
                        line-height: 1.5;
                    }
                    .filter-card input[type="date"].form-control {
                        line-height: 1.25;
                    }
                    .filter-card .lf-filter-actions .btn {
                        height: 38px;
                        min-height: 38px;
                        box-sizing: border-box;
                        padding: 0 0.75rem;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .filter-card .lf-filter-label {
                        min-height: 1.15rem;
                        margin-bottom: 0.35rem;
                        display: block;
                    }
                    @media (max-width: 767.98px) {
                        .filter-card { padding: 1rem !important; }
                        .filter-card .form-control,
                        .filter-card select.form-control,
                        .filter-card .lf-filter-actions .btn {
                            min-height: 44px;
                            height: 44px;
                        }
                    }
                    .custom-table thead th { background: #f8f9fa; border-top: none; color: #7d7d7d; font-weight: 600; text-transform: uppercase; font-size: 0.62rem; padding: 10px 8px; }
                    .custom-table tbody td { padding: 8px 8px; vertical-align: middle; border-top: 1px solid #f0f0f0; font-size: 0.8rem; }
                    /* Modales alineados a ListadoDocumentosSoporte (nota anulación / industrial) */
                    .lf-ds-modal .modal-content {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        box-shadow: 0 12px 32px rgba(0,0,0,0.08) !important;
                        overflow: hidden;
                    }
                    .lf-ds-modal .modal-header.lf-ds-modal-head {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    }
                    .lf-ds-modal .modal-header.lf-ds-modal-head .modal-title {
                        font-size: 1rem;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .lf-ds-modal .modal-header.lf-ds-modal-head .close {
                        color: #323a45;
                        opacity: 0.65;
                        text-shadow: none;
                    }
                    .lf-ds-alert-info-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(23, 162, 184, 0.28);
                        background: rgba(23, 162, 184, 0.09);
                        color: #0c5460;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                    }
                    .lf-ds-alert-caution-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(212, 167, 44, 0.35);
                        background: linear-gradient(180deg, #fffdf8 0%, #fff8ec 100%);
                        color: #5c4508;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                    }
                    .lf-ds-alert-success-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(40, 167, 69, 0.28);
                        background: linear-gradient(180deg, #f9fdf9 0%, #eef7f0 100%);
                        color: #1e4d2a;
                        padding: 14px 16px;
                        font-size: 0.9rem;
                    }
                    .lf-ds-alert-danger-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(220, 53, 69, 0.28);
                        background: linear-gradient(180deg, #fffbfb 0%, #fdeff0 100%);
                        color: #721c24;
                        padding: 14px 16px;
                        font-size: 0.9rem;
                    }
                    .lf-ds-dian-detail-panel {
                        border-radius: 12px;
                        border: 1px solid rgba(0,0,0,0.08);
                        background: #fff;
                        padding: 16px 18px;
                        margin-top: 14px;
                    }
                    .lf-ds-dian-detail-panel .lf-dian-label {
                        font-size: 0.68rem;
                        font-weight: 700;
                        text-transform: uppercase;
                        letter-spacing: 0.05em;
                        color: #6c757d;
                        margin-bottom: 6px;
                    }
                    .lf-ds-dian-detail-panel .lf-dian-uuid {
                        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Courier New", monospace;
                        font-size: 0.78rem;
                        color: #2c3e50;
                        word-break: break-all;
                        line-height: 1.5;
                        background: #f4f6f8;
                        padding: 10px 12px;
                        border-radius: 8px;
                        border: 1px solid rgba(0,0,0,0.06);
                    }
                    .lf-ds-dian-detail-panel .lf-dian-badge {
                        font-size: 0.8rem;
                        font-weight: 600;
                        padding: 0.35em 0.75em;
                        border-radius: 999px;
                    }
                    .lf-dian-debug-modal .modal-dialog {
                        max-width: min(720px, calc(100vw - 2rem));
                    }
                    .lf-dian-debug-modal.lf-dian-debug-modal--wide .modal-dialog {
                        max-width: min(960px, calc(100vw - 2rem));
                    }
                    /* NC no electrónica: alto máximo y scroll en el cuerpo (footer siempre visible) */
                    .lf-ds-modal.lf-nc-ne-modal .modal-dialog {
                        max-height: calc(100vh - 1rem);
                        margin: 0.5rem auto;
                    }
                    .lf-ds-modal.lf-nc-ne-modal .modal-content {
                        max-height: calc(100vh - 1rem);
                        display: flex;
                        flex-direction: column;
                    }
                    .lf-ds-modal.lf-nc-ne-modal .modal-content > form {
                        display: flex;
                        flex-direction: column;
                        min-height: 0;
                        flex: 1 1 auto;
                        max-height: 100%;
                    }
                    .lf-ds-modal.lf-nc-ne-modal .modal-body {
                        overflow-y: auto;
                        -webkit-overflow-scrolling: touch;
                        flex: 1 1 auto;
                        min-height: 0;
                    }
                    .lf-ds-modal.lf-nc-ne-modal .modal-footer {
                        flex-shrink: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item active">Listado de Facturas</li>
                                    </ol>
                                </div>
                            </div>
                            {/* Título de página */}
                            <div className="row mb-2 align-items-center">
                                <div className="col-sm-12">
                                    <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem' }}>Listado de Facturas</h1>
                                </div>
                            </div>
                            {/* Dashboard Stats */}
                            <div className="row mb-4">
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{background: 'rgba(23, 162, 184, 0.1)', color: '#17a2b8'}}><i className="fas fa-file-invoice"></i></div>
                                        <div><div className="card-label">Facturas</div><div className="card-value">{totales.conteo}</div><div className="card-subtext">Registros totales</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{background: 'rgba(40, 167, 69, 0.1)', color: '#28a745'}}><i className="fas fa-dollar-sign"></i></div>
                                        <div><div className="card-label">Total</div><div className="card-value">${Math.round(totales.total).toLocaleString('es-CO')}</div><div className="card-subtext">Venta Bruta</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{background: 'rgba(0, 123, 255, 0.1)', color: '#007bff'}}><i className="fas fa-cash-register"></i></div>
                                        <div><div className="card-label">Cobrado</div><div className="card-value">${Math.round(totales.recaudado).toLocaleString('es-CO')}</div><div className="card-subtext">{Math.round((totales.recaudado / (totales.total || 1)) * 100)}% recaudado</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{background: 'rgba(255, 193, 7, 0.1)', color: '#ffc107'}}><i className="fas fa-clock"></i></div>
                                        <div><div className="card-label">Pendiente</div><div className="card-value">${Math.round(totales.pendiente).toLocaleString('es-CO')}</div><div className="card-subtext">Cartera activa</div></div>
                                    </div>
                                </div>
                            </div>
                            {/* Filtros */}
                            <div className="filter-card p-4 mb-4">
                                {/* Fila 1: Fechas, Estado Factura, Estado DIAN, Tipo Factura, Nro. Factura */}
                                <div className="row align-items-end">
                                    <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Fecha Inicio</label>
                                        <input type="date" className="form-control" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Fecha Fin</label>
                                        <input type="date" className="form-control" value={fechaFin} onChange={e => setFechaFin(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Estado Factura</label>
                                        <select className="form-control" value={estadoFacturaFiltro} onChange={e => setEstadoFacturaFiltro(e.target.value)}>
                                            <option value="">Todas</option>
                                            <option value="cobrada">Cobrada</option>
                                            <option value="por_cobrar">Por Cobrar</option>
                                            <option value="anulada">Anulada</option>
                                            <option value="borrador">Borrador</option>
                                        </select>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Estado DIAN</label>
                                        <select className="form-control" value={estadoDianFiltro} onChange={e => setEstadoDianFiltro(e.target.value)}>
                                            <option value="">Todas</option>
                                            <option value="enviada">Enviada</option>
                                            <option value="no_enviada">No enviada</option>
                                            <option value="en_proceso">En proceso</option>
                                            <option value="borrador_dian">Borrador</option>
                                        </select>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Tipo Factura</label>
                                        <select 
                                            className="form-control" 
                                            value={tipoFacturaFiltro} 
                                            onChange={e => setTipoFacturaFiltro(e.target.value)}
                                            disabled={estadoDianFiltro !== ''}
                                        >
                                            <option value="">Todas</option>
                                            <option value="electronica">Electrónica</option>
                                            <option value="no_electronica">No Electrónica</option>
                                        </select>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Nro. Factura</label>
                                        <input type="text" className="form-control" placeholder="Nro..." value={numeroFactura} onChange={e => setNumeroFactura(e.target.value)} />
                                    </div>
                                </div>
                                {/* Fila 2: Profesional, Paciente, Identificación, Método de Pago, Nueva Factura */}
                                <div className="row mt-2 align-items-end">
                                    <div className="col-12 col-sm-6 col-md-3 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Profesional</label>
                                        <select className="form-control" value={usuarioFiltro} onChange={e => setUsuarioFiltro(e.target.value)}>
                                            <option value="">Todos</option>
                                            {usuarios.map(usuario => (
                                                <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-12 col-md-3 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Paciente</label>
                                        <input type="text" className="form-control" placeholder="Buscar por nombre..." value={busquedaPaciente} onChange={e => setBusquedaPaciente(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-md-2 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Identificación</label>
                                        <input type="text" className="form-control" placeholder="Documento..." value={busquedaDocumento} onChange={e => setBusquedaDocumento(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
                                        <label className="small font-weight-bold lf-filter-label">Método de Pago</label>
                                        <select className="form-control" value={metodoPagoFiltro} onChange={e => setMetodoPagoFiltro(e.target.value)}>
                                            <option value="">Todos</option>
                                            {FORMA_PAGO_OPCIONES.map(op => (
                                                <option key={op.value} value={op.value}>{op.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-12 col-md-2 mb-2 mb-md-0 lf-filter-actions" style={{ position: 'relative' }}>
                                        <label className="small font-weight-bold lf-filter-label opacity-0 user-select-none" aria-hidden="true">&nbsp;</label>
                                        <button type="button" className="btn btn-primary w-100" style={{ borderRadius: '10px' }} onClick={() => setShowDropdownFactura(!showDropdownFactura)}><i className="fas fa-plus mr-2"></i> Nueva Factura</button>
                                        {showDropdownFactura && (
                                            <div className="dropdown-menu show shadow-lg border-0" style={{ position: 'absolute', top: '100%', right: '0', zIndex: 1000, borderRadius: '12px', minWidth: '200px' }}>
                                                <Link to="/crear-factura" className="dropdown-item py-2"><i className="fas fa-file-invoice-dollar mr-2 text-info"></i> Electrónica (DIAN)</Link>
                                                <Link to="/crear-factura-no-electronica" className="dropdown-item py-2"><i className="fas fa-receipt mr-2 text-secondary"></i> No Electrónica </Link>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* Tabla */}
                            <div className="card shadow-sm border-0" style={{borderRadius: '16px', overflow: 'hidden'}}>
                                <div className="card-body p-0" style={{overflowX: 'auto'}}>
                                    <table className="table custom-table mb-0" style={{minWidth: '1150px'}}>
                                        <thead>
                                            <tr>
                                                <th>N° Factura</th>
                                                <th>Fecha</th>
                                                <th>Paciente</th>
                                                <th>Profesional</th>
                                                <th>Forma de pago</th>
                                                <th className="text-right">Total</th>
                                                <th className="text-right">Por Cobrar</th>
                                                <th className="text-center">Tipo</th>
                                                <th className="text-center">DIAN</th>
                                                <th className="text-center">Estado</th>
                                                <th className="text-center" width="70">ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pagination.paginatedItems.map((f) => {
                                                const est = parseInt(f.estado);
                                                const sal = parseFloat(f.valor_pendiente || 0);
                                                const esNoElectronica = f.tipo_factura === 'no_electronica' || [4, 5].includes(est);
                                                const dianStatus = esNoElectronica ? 'no_aplica' : ([1, 2, 3].includes(est) ? 'enviado' : 'no_enviado');
                                                const dianBadgeStyle = dianStatus === 'enviado'
                                                    ? { background: 'rgba(40, 167, 69, 0.08)', color: '#28a745', border: '1px solid rgba(40, 167, 69, 0.22)', borderRadius: '10px' }
                                                    : dianStatus === 'no_aplica'
                                                        ? { background: 'rgba(108, 117, 125, 0.08)', color: '#6c757d', border: '1px solid rgba(108, 117, 125, 0.22)', borderRadius: '10px' }
                                                        : { background: 'rgba(250, 173, 20, 0.10)', color: '#faad14', border: '1px solid rgba(250, 173, 20, 0.22)', borderRadius: '10px' };
                                                return (
                                                    <tr key={f.id}>
                                                        <td>
                                                            <div className="d-flex flex-column">
                                                                <span style={{ color: '#17a2b8', fontWeight: 700 }}>{etiquetaNumeroFactura(f)}</span>
                                                                <span style={{ fontSize: '0.65rem', color: '#8c8c8c' }}>{f.fev === 1 ? 'DIAN ELECTRÓNICA' : ''}</span>
                                                            </div>
                                                        </td>
                                                        <td className="text-muted text-center">{formatearFecha(f.fecha_emision)}</td>
                                                        <td><div style={{ fontWeight: 600, color: '#323a45' }}>{getNombrePaciente(f.paciente_id)}</div></td>
                                                        <td style={{ color: '#8c8c8c' }}>{getNombreUsuario(f.users_id)}</td>
                                                        <td>
                                                            {f.forma_pago && f.forma_pago !== 'PENDIENTE'
                                                                ? getMedioPagoTexto(f.forma_pago)
                                                                : '—'}
                                                        </td>
                                                        <td className="text-right"><strong>{formatearValor(f.valor_total)}</strong></td>
                                                        <td className="text-right"><strong style={{ color: sal > 0 ? '#faad14' : '#52c41a' }}>{formatearValor(sal)}</strong></td>
                                                        <td className="text-center">
                                                            <span className="badge" style={{ background: esNoElectronica ? 'rgba(108, 117, 125, 0.08)' : 'rgba(23, 162, 184, 0.1)', border: `1px solid ${esNoElectronica ? 'rgba(108, 117, 125, 0.25)' : 'rgba(23, 162, 184, 0.25)'}`, color: esNoElectronica ? '#6c757d' : '#17a2b8' }}>
                                                                <i className={`fas ${esNoElectronica ? 'fa-file-alt' : 'fa-bolt'} mr-1`}></i>
                                                                {esNoElectronica ? 'No electrónica' : 'Electrónica'}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span
                                                                className="badge"
                                                                style={{
                                                                    ...dianBadgeStyle,
                                                                    fontWeight: 700,
                                                                    fontSize: '0.7rem',
                                                                    padding: '6px 10px'
                                                                }}
                                                            >
                                                                {esNoElectronica ? 'NO APLICA' : ([1, 2, 3].includes(est) ? 'ENVIADO' : 'NO ENVIADO')}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span
                                                                className="badge"
                                                                style={{
                                                                    ...getEstadoBadgeStyle(est),
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 700,
                                                                    padding: '6px 10px'
                                                                }}
                                                            >
                                                                {getEstadoTexto(est)}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <button className="btn btn-sm btn-light border" style={{borderRadius: '8px'}} onClick={() => handleAbrirAcciones(f)}><i className="fas fa-ellipsis-v"></i></button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <ReportPaginationFooter
                                    totalRegistros={pagination.totalRegistros}
                                    indicePrimerRegistro={pagination.indicePrimerRegistro}
                                    indiceUltimoRegistro={pagination.indiceUltimoRegistro}
                                    paginaActual={pagination.paginaActual}
                                    cambiarPagina={cambiarPaginaFacturas}
                                    totalPaginas={pagination.totalPaginas}
                                    registrosPorPagina={pagination.registrosPorPagina}
                                    onPageSizeChange={pagination.handlePageSizeChange}
                                    itemLabel="facturas"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer and Modals */}
                <Footer showToast={false} delay={0} />
                {/* Modal Recibo de Caja */}
                {showModalRecibo && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-dialog-centered shadow-lg">
                            <div className="modal-content border-0" style={{borderRadius: '16px'}}>
                                <div className="modal-header border-0 bg-light">
                                    <h6 className="modal-title font-weight-bold">Registrar Recibo</h6>
                                    <button type="button" className="close" onClick={() => setShowModalRecibo(false)}><span>&times;</span></button>
                                </div>
                                <div className="modal-body p-4">
                                    <div className="form-group mb-3">
                                        <label className="small text-muted d-block">Factura / saldo pendiente</label>
                                        <div className="border rounded px-3 py-2 bg-light">
                                            <div className="font-weight-bold">N° {facturaSeleccionada?.numero_factura}</div>
                                            <div className="small text-muted mb-0">
                                                Saldo pendiente (informativo):{' '}
                                                <strong className="text-dark">${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="small text-muted">Valor a recibir</label>
                                        <div className="lf-recibo-valor-group">
                                            <span className="lf-recibo-moneda-icon" title="Pesos colombianos">
                                                <i className="fas fa-dollar-sign" aria-hidden="true"></i>
                                            </span>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                className="form-control lf-recibo-valor-input"
                                                value={valorRecibo}
                                                onChange={handleValorReciboChange}
                                                placeholder="0"
                                                autoComplete="off"
                                            />
                                        </div>
                                        <small className="text-muted">
                                            Máximo: ${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}
                                        </small>
                                    </div>
                                    <div className="form-group">
                                        <label className="small text-muted">Medio de Pago</label>
                                        <select className="form-control" value={medioPago} onChange={e => setMedioPago(e.target.value)}>
                                            {FORMA_PAGO_OPCIONES.map((op) => (
                                                <option key={op.value} value={op.value}>{op.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group"><label className="small text-muted">Fecha Pago</label><input type="date" className="form-control" value={fechaPago} onChange={e => setFechaPago(e.target.value)} /></div>
                                    <div className="form-group"><label className="small text-muted">Observaciones</label><textarea className="form-control" rows="2" value={observacionesRecibo} onChange={e => setObservacionesRecibo(e.target.value)}></textarea></div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button className="btn btn-light" onClick={() => setShowModalRecibo(false)}>Cancelar</button>
                                    <button className="btn btn-info px-4" style={{borderRadius: '10px'}} onClick={guardarRecibo}>Guardar Pago</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* Modal éxito recibo de caja */}
                {showModalExitoRecibo && reciboGuardado && (
                    <Modal
                        show={showModalExitoRecibo}
                        onHide={() => { setShowModalExitoRecibo(false); setReciboGuardado(null); }}
                        centered
                        dialogClassName="mx-exito-dialog"
                        contentClassName="mx-exito-content"
                    >
                        <Modal.Header closeButton className="mx-exito-head">
                            <Modal.Title>
                                <span className="mx-exito-head-icon">
                                    <i className="fas fa-check"></i>
                                </span>
                                Recibo registrado
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="mx-exito-body">
                            <div className="mx-exito-hero" aria-hidden="true">
                                <i className="fas fa-check"></i>
                            </div>
                            <h5 className="mx-exito-title">Recibo registrado exitosamente</h5>
                            <p className="mx-exito-label mb-0">Número de Recibo:</p>
                            <div className="mx-exito-numero">
                                {reciboGuardado.numero_recibo
                                    || (reciboGuardado.recibo_id != null ? String(reciboGuardado.recibo_id) : '—')}
                            </div>
                            <p className="text-muted small mt-2 mb-0">
                                Valor:{' '}
                                <strong>
                                    ${Math.round(parseFloat(reciboGuardado.valor_pago || reciboGuardado.valor_recibido || parseMontoRecibo(valorRecibo) || 0)).toLocaleString('es-CO')}
                                </strong>
                                {facturaSeleccionada?.numero_factura && (
                                    <> · Factura N° {facturaSeleccionada.numero_factura}</>
                                )}
                            </p>
                        </Modal.Body>
                        <Modal.Footer className="mx-exito-footer">
                            <Button
                                className="mx-exito-btn-outline mx-exito-btn-outline--teal"
                                onClick={() => {
                                    vistaPreviaRecibo(reciboGuardado);
                                }}
                            >
                                <i className="fas fa-eye mr-2"></i> Ver / imprimir
                            </Button>
                            <Button
                                className="mx-exito-btn-outline mx-exito-btn-outline--gray"
                                onClick={() => { setShowModalExitoRecibo(false); setReciboGuardado(null); }}
                            >
                                <i className="fas fa-times mr-2"></i> Cerrar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {/* Modal Ver Recibos */}
                {showModalRecibos && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content border-0" style={{borderRadius: '16px'}}>
                                <div className="modal-header border-0 bg-light">
                                    <h6 className="modal-title font-weight-bold">Historial de Pagos - Factura #{facturaSeleccionada?.numero_factura}</h6>
                                    <button type="button" className="close" onClick={() => setShowModalRecibos(false)}><span>&times;</span></button>
                                </div>
                                <div className="modal-body p-0">
                                    <table className="table mb-0 small">
                                        <thead className="bg-light"><tr><th>Recibo</th><th>Fecha</th><th className="text-right">Valor</th><th>Estado</th><th>Acciones</th></tr></thead>
                                        <tbody>
                                            {recibosFactura.map(r => (
                                                <tr key={r.id}>
                                                    <td>{r.numero_recibo}</td>
                                                    <td>{formatearFecha(r.fecha_pago)}</td>
                                                    <td className="text-right font-weight-bold">{formatearValor(r.valor_pago)}</td>
                                                    <td><span className={`badge ${r.estado === 0 ? 'badge-danger' : 'badge-success'}`}>{r.estado === 0 ? 'Anulado' : 'Activo'}</span></td>
                                                    <td>
                                                        <button className="btn btn-xs btn-outline-info mr-1" onClick={() => vistaPreviaRecibo(r)}><i className="fas fa-eye"></i></button>
                                                        {r.estado !== 0 && <button className="btn btn-xs btn-outline-danger" onClick={() => anularRecibo(r.id)}><i className="fas fa-ban"></i></button>}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer border-0"><button className="btn btn-light" onClick={() => setShowModalRecibos(false)}>Cerrar</button></div>
                            </div>
                        </div>
                    </div>
                )}
                {/* Action Modal (Centralizado) */}
                {showModalAcciones && facturaAccion && (
                    <div className="modal fade show" style={{display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 9999}}>
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content border-0 shadow-lg" style={{borderRadius: '20px', overflow: 'hidden'}}>
                                <div className="modal-header border-0 pb-0" style={{background: '#f8f9fa'}}>
                                    <h6 className="modal-title font-weight-bold small">
                                        OPCIONES {esBorradorFacturaElectronica(facturaAccion) ? 'Borrador#' : `N° ${facturaAccion.numero_factura}`}
                                    </h6>
                                    <button type="button" className="close" onClick={() => setShowModalAcciones(false)}><span>&times;</span></button>
                                </div>
                                <div className="modal-body p-3">
                                    <div className="list-group list-group-flush">
                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { abrirInformacionFactura(facturaAccion.id); setShowModalAcciones(false); }} style={{borderRadius: '12px', background: 'rgba(23, 162, 184, 0.05)'}}>
                                            <i className="fas fa-eye mr-2 text-info"></i> Ver factura
                                        </button>
                                        {!esFacturaNoElectronica(facturaAccion) && parseInt(facturaAccion.estado, 10) === 0 && (
                                            <button
                                                type="button"
                                                className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                onClick={() => {
                                                    setShowModalAcciones(false);
                                                    enviarFacturaDian(facturaAccion.id, false, facturaAccion);
                                                }}
                                                style={{ borderRadius: '12px', background: 'rgba(23, 162, 184, 0.12)' }}
                                            >
                                                <i className="fas fa-paper-plane mr-2 text-info"></i> Enviar a la DIAN
                                            </button>
                                        )}
                                        {parseInt(facturaAccion.estado, 10) === 6 && (
                                            <>
                                                <button
                                                    type="button"
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    onClick={() => {
                                                        setShowModalAcciones(false);
                                                        comprobarEstadoDian(facturaAccion.id);
                                                    }}
                                                    disabled={comprobandoEstadoDian}
                                                    style={{ borderRadius: '12px', background: 'rgba(23, 162, 184, 0.12)' }}
                                                >
                                                    <i className={`fas ${comprobandoEstadoDian ? 'fa-spinner fa-spin' : 'fa-sync-alt'} mr-2 text-info`}></i> 
                                                    {comprobandoEstadoDian ? 'Comprobando...' : 'Actualizar Estado'}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    onClick={() => {
                                                        setShowModalAcciones(false);
                                                        enviarFacturaDian(facturaAccion.id, true);
                                                    }}
                                                    style={{ borderRadius: '12px', background: 'rgba(255, 193, 7, 0.15)' }}
                                                >
                                                    <i className="fas fa-redo mr-2 text-warning"></i> Reenviar a la DIAN
                                                </button>
                                            </>
                                        )}
                                        {parseInt(facturaAccion.estado, 10) === 7 && (
                                            <button
                                                className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                onClick={() => {
                                                    abrirCompletarDatos(facturaAccion.id);
                                                    setShowModalAcciones(false);
                                                }}
                                                style={{ borderRadius: '12px', background: 'rgba(40, 167, 69, 0.08)' }}
                                            >
                                                <i className="fas fa-file-invoice-dollar mr-2 text-success"></i> Facturar
                                            </button>
                                        )}
                                        {(facturaAccion.estado === 2 || facturaAccion.estado === 5) && (
                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { abrirModalRecibo(facturaAccion); setShowModalAcciones(false); }} style={{borderRadius: '12px'}}>
                                                <i className="fas fa-cash-register mr-2 text-success"></i> Registrar Pago
                                            </button>
                                        )}
                                        {!esFacturaContado(facturaAccion) && (
                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { verRecibos(facturaAccion); setShowModalAcciones(false); }} style={{borderRadius: '12px'}}>
                                                <i className="fas fa-history mr-2 text-secondary"></i> Ver Recibos
                                            </button>
                                        )}
                                        {parseInt(facturaAccion.estado, 10) !== 3 && (() => {
                                            const accionAnular = getEtiquetaAccionAnular(facturaAccion);
                                            const bloqueadoPorComprobacion = parseInt(facturaAccion.estado, 10) === 6 && comprobandoEstadoDian;
                                            return (
                                            <button
                                                className={`list-group-item list-group-item-action border-0 d-flex align-items-center ${accionAnular.clase}`}
                                                onClick={() => { abrirFlujoAnularFactura(facturaAccion); setShowModalAcciones(false); }}
                                                disabled={bloqueadoPorComprobacion}
                                                style={{borderRadius: '12px'}}
                                            >
                                                <i className={`fas ${bloqueadoPorComprobacion ? 'fa-spinner fa-spin' : accionAnular.icono} mr-2`}></i>
                                                {bloqueadoPorComprobacion ? 'Verificando DIAN...' : accionAnular.texto}
                                            </button>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito Electrónica */}
                {showModalNotaCredito && (
                    <div className="modal fade show lf-ds-modal lf-nc-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 10050 }} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                            <div className="modal-content border-0 shadow">
                                <div className="modal-header lf-ds-modal-head">
                                    <h4 className="modal-title mb-0">
                                        <i className="fas fa-file-invoice mr-2 text-info"></i>
                                        Generar Nota Crédito Electrónica
                                    </h4>
                                    <button type="button" className="close" onClick={() => setShowModalNotaCredito(false)} aria-label="Cerrar">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="lf-ds-alert-info-soft mb-3">
                                        <strong>Factura:</strong> {facturaSeleccionada?.numero_factura}<br />
                                        <strong>Paciente:</strong> {getNombrePaciente(facturaSeleccionada?.paciente_id)}<br />
                                        {esFacturaContado(facturaSeleccionada) ? (
                                            <>
                                                <strong>Venta de contado:</strong> nota crédito por el <strong>valor total</strong> (${Math.round(getValorTotalNum(facturaSeleccionada)).toLocaleString('es-CO')}) — anulación completa.
                                            </>
                                        ) : (
                                            <>
                                                <strong>Saldo pendiente:</strong> ${Math.round(getSaldoPendienteNum(facturaSeleccionada)).toLocaleString('es-CO')}
                                            </>
                                        )}
                                    </div>

                                    {notasCreditoExistentes.length > 0 && (
                                        <div className="lf-ds-alert-caution-soft mb-3">
                                            <strong>Notas crédito ya registradas en esta factura:</strong>
                                            <ul className="mb-0 mt-2 pl-3 small">
                                                {notasCreditoExistentes.map((nc) => (
                                                    <li key={nc.id}>
                                                        {nc.prefijo || ''}{nc.numero_nc || '—'}
                                                        {' · '}${Math.round(parseFloat(nc.valor_total || 0)).toLocaleString('es-CO')}
                                                        {nc.uuid ? ' · DIAN OK' : ''}
                                                    </li>
                                                ))}
                                            </ul>
                                            <p className="mb-0 mt-2 small text-muted">
                                                Total acreditado: ${Math.round(sumaNotasCreditoExistentes).toLocaleString('es-CO')}.
                                                {esFacturaContado(facturaSeleccionada)
                                                    ? ' En contado solo puede existir una NC total.'
                                                    : ' Verifique el saldo pendiente antes de enviar otra.'}
                                            </p>
                                        </div>
                                    )}

                                    {ripsAsociadoNc?.tiene_rips && (
                                        <div className="lf-ds-alert-danger-soft mb-3">
                                            <strong>
                                                <i className="fas fa-exclamation-triangle mr-1"></i>
                                                RIPS asociado a esta factura
                                            </strong>
                                            <p className="mb-1 mt-2">
                                                {ripsAsociadoNc.tiene_enviado_sispro
                                                    ? 'Hay RIPS ya enviado a SISPRO. Si genera una NC total y la factura queda anulada, el RIPS se anulará en SmileWEB; gestione la novedad ante el Ministerio si aplica.'
                                                    : 'Hay RIPS ligado a esta FEV. Un RIPS con factura electrónica solo es válido si la FEV está enviada: al anular con NC total se eliminará el RIPS del sistema.'}
                                            </p>
                                            {(ripsAsociadoNc.cantidad || 0) > 0 && (
                                                <p className="mb-0 small text-muted">
                                                    {ripsAsociadoNc.cantidad} RIPS vinculado(s)
                                                    {ripsAsociadoNc.tiene_enviado_sispro ? ' · incluye envío SISPRO' : ' · sin envío SISPRO'}.
                                                </p>
                                            )}
                                            {tipoNotaCredito === 'parcial' && (
                                                <p className="mb-0 mt-2 small">
                                                    Con NC parcial el RIPS se mantiene mientras la factura no quede anulada por completo.
                                                </p>
                                            )}
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Prefijo *</label>
                                                <select
                                                    className="form-control"
                                                    value={prefijoSeleccionado}
                                                    onChange={handlePrefijoChange}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {prefijos.map(prefijo => (
                                                        <option key={prefijo.id} value={prefijo.id}>
                                                            {prefijo.prefijo}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>N° Nota Crédito *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={numeroNotaCredito}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Fecha Nota Crédito *</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaNotaCredito}
                                                    onChange={(e) => setFechaNotaCredito(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Tipo de Nota Crédito *</label>
                                                <select
                                                    className="form-control"
                                                    value={tipoNotaCredito}
                                                    onChange={(e) => {
                                                        const nuevoTipo = e.target.value;
                                                        setTipoNotaCredito(nuevoTipo);
                                                        if (nuevoTipo === 'total') {
                                                            setValorNotaCredito(getImporteNcTipoTotal(facturaSeleccionada));
                                                        } else {
                                                            setValorNotaCredito('');
                                                        }
                                                    }}
                                                >
                                                    <option value="total">
                                                        {esFacturaContado(facturaSeleccionada)
                                                            ? 'Total (anulación completa — valor de la factura)'
                                                            : 'Total (saldo pendiente completo)'}
                                                    </option>
                                                    {!esFacturaContado(facturaSeleccionada) && (
                                                        <option value="parcial">Parcial (solo facturas a crédito)</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Valor a Acreditar *</label>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">$</span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorNotaCredito}
                                                        onChange={(e) => setValorNotaCredito(e.target.value)}
                                                        readOnly={tipoNotaCredito === 'total'}
                                                        max={esFacturaContado(facturaSeleccionada) ? getValorTotalNum(facturaSeleccionada) : getSaldoPendienteNum(facturaSeleccionada)}
                                                        required
                                                    />
                                                </div>
                                                {tipoNotaCredito === 'parcial' && (
                                                    <small className="form-text text-muted">Indique el valor a acreditar (no mayor al saldo pendiente).</small>
                                                )}
                                                {tipoNotaCredito === 'total' && esFacturaContado(facturaSeleccionada) && (
                                                    <small className="form-text text-info">Se emite por el valor total de la factura (venta de contado).</small>
                                                )}
                                                {tipoNotaCredito === 'total' && !esFacturaContado(facturaSeleccionada) && (
                                                    <small className="form-text text-info">Se acreditará el saldo pendiente completo.</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Motivo *</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={motivoNotaCredito}
                                                    onChange={(e) => setMotivoNotaCredito(e.target.value)}
                                                    placeholder="Describa la razón de la nota crédito..."
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer border-0 bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCredito(false)} disabled={loadingNC}>Cancelar</button>
                                    <button type="button" className="btn btn-info" onClick={generarNotaCredito} disabled={loadingNC || (esFacturaContado(facturaSeleccionada) && notasCreditoExistentes.length > 0)}>
                                        {loadingNC ? (
                                            <><i className="fas fa-spinner fa-spin mr-1"></i> Enviando a DIAN...</>
                                        ) : (
                                            <><i className="fas fa-paper-plane mr-1"></i> Generar y Enviar a DIAN</>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal resultado envío DIAN / vista JSON (estilo alineado a lf-ds-modal) */}
                {showModalDebug && (
                    <div
                        className={`modal fade show lf-ds-modal lf-dian-debug-modal${debugType !== 'success' ? ' lf-dian-debug-modal--wide' : ''}`}
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 10050 }}
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                            <div className="modal-content border-0 shadow">
                                <div className="modal-header lf-ds-modal-head align-items-center">
                                    <h5 className="modal-title mb-0 d-flex align-items-center font-weight-bold">
                                        {debugType === 'success' && (
                                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2" style={{ width: 36, height: 36, background: 'rgba(40, 167, 69, 0.12)', color: '#28a745' }}>
                                                <i className="fas fa-check"></i>
                                            </span>
                                        )}
                                        {debugType === 'json' && (
                                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2" style={{ width: 36, height: 36, background: 'rgba(23, 162, 184, 0.12)', color: '#17a2b8' }}>
                                                <i className="fas fa-code"></i>
                                            </span>
                                        )}
                                        {debugType !== 'success' && debugType !== 'json' && (
                                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2" style={{ width: 36, height: 36, background: 'rgba(220, 53, 69, 0.12)', color: '#dc3545' }}>
                                                <i className="fas fa-exclamation"></i>
                                            </span>
                                        )}
                                        {debugType === 'success'
                                            ? 'Envío a la DIAN'
                                            : debugType === 'json'
                                            ? 'Vista previa — JSON'
                                            : (debugData?.titulo || 'No se pudo enviar a la DIAN')}
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalDebug(false)} aria-label="Cerrar">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body pt-3 pb-2">
                                    {debugType === 'success' ? (
                                        <div>
                                            <div className="lf-ds-alert-success-soft mb-0">
                                                <strong className="d-block mb-1">{mensajeClienteSinCodigoEstado(debugData?.message || 'Operación completada.')}</strong>
                                                <span className="text-muted small d-block" style={{ lineHeight: 1.45 }}>
                                                    El proveedor de emisión confirmó el documento. Guarde el CUDE o UUID para sus registros.
                                                </span>
                                            </div>
                                            <div className="lf-ds-dian-detail-panel">
                                                <div className="lf-dian-label">CUDE / UUID</div>
                                                <div className="lf-dian-uuid">{debugData?.uuid || debugData?.cufe || '—'}</div>
                                                {debugData?.numero_nc ? (
                                                    <div className="mt-3">
                                                        <div className="lf-dian-label">Nota crédito</div>
                                                        <span className="lf-dian-badge badge badge-success">{debugData.numero_nc}</span>
                                                        {debugData?.recibos_anulados > 0 && (
                                                            <span className="lf-dian-badge badge badge-warning ml-2">Recibos anulados: {debugData.recibos_anulados}</span>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="mt-3">
                                                        <div className="lf-dian-label">Estado en sistema</div>
                                                        <span
                                                            className={`lf-dian-badge badge ${debugData?.estado === 1 ? 'badge-success' : 'badge-info'}`}
                                                        >
                                                            {debugData?.estado === 1 ? 'Cobrada (contado)' : 'Por cobrar (crédito)'}
                                                        </span>
                                                    </div>
                                                )}
                                                {(debugData?.pdf_url || debugData?.xml_url) && (
                                                    <div className="mt-3">
                                                        <div className="lf-dian-label mb-2">Documentos DIAN</div>
                                                        <div className="btn-group" role="group">
                                                            {debugData.pdf_url && (
                                                                <a
                                                                    href={debugData.pdf_url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    download
                                                                >
                                                                    <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                                                                </a>
                                                            )}
                                                            {debugData.xml_url && (
                                                                <a
                                                                    href={debugData.xml_url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-success"
                                                                    download
                                                                >
                                                                    <i className="fas fa-file-code mr-1"></i> Descargar XML
                                                                </a>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-info"
                                                        onClick={() => {
                                                            const p = getSpaPathPrefix();
                                                            window.location.href = `${window.location.origin}${p}/#/informacion-factura/${debugData.facturaId}`;
                                                        }}
                                                    >
                                                        <i className="fas fa-file-invoice mr-1"></i> Ver factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : debugType === 'json' && debugData?.json ? (
                                        <pre
                                            className="mb-0"
                                            style={{
                                                backgroundColor: '#f4f6f8',
                                                padding: '14px 16px',
                                                borderRadius: '12px',
                                                maxHeight: 'min(520px, 70vh)',
                                                overflow: 'auto',
                                                fontSize: '12px',
                                                whiteSpace: 'pre-wrap',
                                                wordBreak: 'break-word',
                                                border: '1px solid rgba(0,0,0,0.06)',
                                                fontFamily: 'ui-monospace, Menlo, Monaco, Consolas, monospace',
                                            }}
                                        >
                                            {JSON.stringify(debugData.json, null, 2)}
                                        </pre>
                                    ) : (
                                        <div>
                                            <div className="lf-ds-alert-danger-soft mb-3">
                                                <strong className="d-block mb-1">Detalle</strong>
                                                <span style={{ lineHeight: 1.5 }}>{mensajeClienteSinCodigoEstado(debugData?.message || 'Ocurrió un error al comunicarse con el servicio de emisión.')}</span>
                                            </div>

                                            {debugData?.response && (
                                                <div className="lf-ds-dian-detail-panel mb-3">
                                                    <div className="lf-dian-label">Respuesta del servicio</div>
                                                    <pre
                                                        className="mb-0"
                                                        style={{
                                                            backgroundColor: '#f4f6f8',
                                                            padding: '12px 14px',
                                                            borderRadius: '8px',
                                                            maxHeight: '280px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordBreak: 'break-word',
                                                            border: '1px solid rgba(0,0,0,0.06)',
                                                            fontFamily: 'ui-monospace, Menlo, Monaco, Consolas, monospace',
                                                        }}
                                                    >
                                                        {JSON.stringify(debugData.response, null, 2)}
                                                    </pre>
                                                </div>
                                            )}

                                            {debugData?.json_enviado && (
                                                <div className="lf-ds-dian-detail-panel mb-0">
                                                    <div className="lf-dian-label">JSON enviado (soporte técnico)</div>
                                                    <pre
                                                        className="mb-0"
                                                        style={{
                                                            backgroundColor: '#f4f6f8',
                                                            padding: '12px 14px',
                                                            borderRadius: '8px',
                                                            maxHeight: '280px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordBreak: 'break-word',
                                                            border: '1px solid rgba(0,0,0,0.06)',
                                                            fontFamily: 'ui-monospace, Menlo, Monaco, Consolas, monospace',
                                                        }}
                                                    >
                                                        {JSON.stringify(debugData.json_enviado, null, 2)}
                                                    </pre>
                                                </div>
                                            )}

                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-info"
                                                        onClick={() => {
                                                            const p = getSpaPathPrefix();
                                                            window.location.href = `${window.location.origin}${p}/#/informacion-factura/${debugData.facturaId}`;
                                                        }}
                                                    >
                                                        <i className="fas fa-file-invoice mr-1"></i> Ver factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer border-top bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito No Electrónica (mismo lenguaje visual que nota anulación en documentos soporte) */}
                {showModalNotaCreditoNE && consecutivoNCNE && (
                    <div className="modal fade show lf-ds-modal lf-nc-ne-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 10050, overflowY: 'auto' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header lf-ds-modal-head">
                                    <h5 className="modal-title mb-0">
                                        <i className="fas fa-file-invoice mr-2 text-info"></i>
                                        Nota crédito — factura no electrónica
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalNotaCreditoNE(false)} aria-label="Cerrar">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form onSubmit={generarNotaCreditoNE}>
                                    <div className="modal-body">
                                        <div className="lf-ds-alert-caution-soft mb-3">
                                            <i className="fas fa-info-circle mr-2 text-warning" style={{ opacity: 0.85 }}></i>
                                            Se registrará la nota crédito en el sistema, se actualizarán saldos y se consumirá el consecutivo de NC no electrónica. No aplica envío a la DIAN.
                                        </div>

                                        <div className="lf-ds-alert-info-soft mb-3">
                                            <strong>Factura:</strong>{' '}
                                            {facturaSeleccionada?.prefijo ? `${facturaSeleccionada.prefijo}-` : ''}{facturaSeleccionada?.numero_factura}
                                            <br />
                                            <strong>Paciente:</strong> {getNombrePaciente(facturaSeleccionada?.paciente_id)}
                                            <br />
                                            {esFacturaContado(facturaSeleccionada) ? (
                                                <>
                                                    <strong>Venta de contado:</strong> nota por el <strong>valor total</strong> (${Math.round(getValorTotalNum(facturaSeleccionada)).toLocaleString('es-CO')}).
                                                </>
                                            ) : (
                                                <>
                                                    <strong>Saldo pendiente:</strong> ${Math.round(getSaldoPendienteNum(facturaSeleccionada)).toLocaleString('es-CO')}
                                                </>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>Consecutivo nota crédito</label>
                                            <input
                                                type="text"
                                                className="form-control bg-light"
                                                readOnly
                                                value={(() => {
                                                    const pr = consecutivoNCNE.prefijo != null && String(consecutivoNCNE.prefijo).trim() !== '' ? String(consecutivoNCNE.prefijo).trim() : null;
                                                    const co = consecutivoNCNE.consecutivo;
                                                    if (pr != null && co != null) return `${pr}-${co}`;
                                                    if (co != null) return String(co);
                                                    return '—';
                                                })()}
                                            />
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Tipo de nota *</label>
                                                    <select
                                                        className="form-control"
                                                        value={esFacturaContado(facturaSeleccionada) ? 'total' : tipoNotaCreditoNE}
                                                        onChange={(e) => {
                                                            const nuevoTipo = e.target.value;
                                                            setTipoNotaCreditoNE(nuevoTipo);
                                                            if (nuevoTipo === 'total') {
                                                                setValorNotaCreditoNE(getImporteNcTipoTotal(facturaSeleccionada));
                                                            } else {
                                                                setValorNotaCreditoNE('');
                                                            }
                                                        }}
                                                        disabled={esFacturaContado(facturaSeleccionada)}
                                                    >
                                                        <option value="total">
                                                            {esFacturaContado(facturaSeleccionada)
                                                                ? 'Total (anulación completa — valor de la factura)'
                                                                : 'Total (saldo pendiente completo)'}
                                                        </option>
                                                        {!esFacturaContado(facturaSeleccionada) && (
                                                            <option value="parcial">Parcial (solo facturas a crédito)</option>
                                                        )}
                                                    </select>
                                                    {esFacturaContado(facturaSeleccionada) && (
                                                        <small className="form-text text-muted">En contado solo aplica nota total.</small>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fecha emisión *</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={fechaNotaCreditoNE}
                                                        onChange={(e) => setFechaNotaCreditoNE(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>Valor a acreditar *</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={valorNotaCreditoNE}
                                                    onChange={(e) => setValorNotaCreditoNE(e.target.value)}
                                                    readOnly={tipoNotaCreditoNE === 'total' || esFacturaContado(facturaSeleccionada)}
                                                    min={0}
                                                    step={1}
                                                    max={esFacturaContado(facturaSeleccionada) ? getValorTotalNum(facturaSeleccionada) : getSaldoPendienteNum(facturaSeleccionada)}
                                                    required
                                                />
                                            </div>
                                            {tipoNotaCreditoNE === 'parcial' && !esFacturaContado(facturaSeleccionada) && (
                                                <small className="form-text text-muted">No mayor al saldo pendiente.</small>
                                            )}
                                        </div>

                                        <div className="form-group mb-0">
                                            <label>Motivo *</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={motivoNotaCreditoNE}
                                                onChange={(e) => setMotivoNotaCreditoNE(e.target.value)}
                                                placeholder="Describa la razón de la nota crédito..."
                                                required
                                            />
                                        </div>

                                        {!esFacturaContado(facturaSeleccionada) && tipoNotaCreditoNE === 'total' && (
                                            <p className="text-muted small mb-0 mt-2">Se acreditará el saldo pendiente completo.</p>
                                        )}
                                    </div>
                                    <div className="modal-footer border-top bg-light">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCreditoNE(false)}>Cancelar</button>
                                        <button type="submit" className="btn btn-info" disabled={loadingNCNE}>
                                            {loadingNCNE ? (
                                                <i className="fas fa-spinner fa-spin mr-1"></i>
                                            ) : (
                                                <i className="fas fa-check mr-1"></i>
                                            )}
                                            Generar nota crédito
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                <CompletarDatosFactura show={showModalCompletarDatos} facturaId={facturaCompletarId} onComplete={handleCompletarDatosSuccess} onCancel={() => setShowModalCompletarDatos(false)} />

                {ripsDataPostFactura && (
                    <ModalRipsExito
                        show={showModalRipsPostFactura}
                        onClose={() => {
                            setShowModalRipsPostFactura(false);
                            setRipsDataPostFactura(null);
                            cargarFacturas();
                        }}
                        ripsData={ripsDataPostFactura}
                        onDescargar={handleDescargarRipsPostFactura}
                        onEnvioExitoso={() => cargarFacturas()}
                    />
                )}
            </div>
        );
    }

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    return <Loading />;
}

export default ListadoFacturas;
